(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3950],{

/***/ 8573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./RBPartnerPortal/templates/AutoraTemplate/_findDesign/Design": [
		17571,
		3442,
		7836,
		7929,
		7460,
		1704
	],
	"./RBPartnerPortal/templates/CastroTemplate/_findDesign/Design": [
		18508,
		3442,
		7836,
		7929,
		7460,
		5961
	],
	"./RBhu/_findDesign/Design": [
		29710,
		3442,
		7836,
		7929,
		7460,
		1994
	],
	"./SZP/_findDesign/Design": [
		41902,
		3442,
		7836,
		7929,
		7460,
		7444
	],
	"./SZPPL/_findDesign/Design": [
		11545,
		3442,
		7836,
		7929,
		7460,
		6148
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8573;
module.exports = webpackAsyncContext;

/***/ }),

/***/ 13950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FindComponent_Find; },
  "filterUrl": function() { return /* binding */ filterUrl; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Stack/Stack.js
var Stack = __webpack_require__(9144);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/contexts/BackendContext.tsx + 1 modules
var BackendContext = __webpack_require__(66230);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/Stack/Stack.js
var Stack_Stack = __webpack_require__(88085);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/contexts/LayoutContext.tsx + 65 modules
var LayoutContext = __webpack_require__(92609);
// EXTERNAL MODULE: ./pages/_app.tsx + 34 modules
var _app = __webpack_require__(23761);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FindFilterBadge.tsx









var FindFilterBadge = function(param) {
    var title = param.title, resetUrl = param.resetUrl, pageUrl = param.pageUrl, colors = param.colors;
    var ref;
    var router = (0,next_router.useRouter)();
    var mmbr = router.query.mmbr;
    var ref1 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref1.partnerSiteFull, templatePath = ref1.templatePath;
    var ref2;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref2 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref2 !== void 0 ? ref2 : "AutoraTemplate") : templatePath;
    var FindBadge = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindBadge;
            });
        });
    }, [
        path
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: resetUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: (pageUrl ? "/" + pageUrl : "") + (resetUrl ? resetUrl : "") + (mmbr ? resetUrl == "/" || resetUrl.slice(-1) !== "/" ? resetUrl.includes("?") ? "&mmbr=".concat(mmbr) : "?mmbr=".concat(mmbr) : "&mmbr=".concat(mmbr) : ""),
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindBadge, {
                    bgcolor: colors.mainColor,
                    bghovercolor: colors.secondaryColor,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            mr: 0.5,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindBadge, {
            bgcolor: colors.mainColor,
            bghovercolor: colors.secondaryColor,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack_Stack/* default */.Z, {
                mr: 0.5,
                children: title
            })
        })
    });
};
/* harmony default export */ var FindComponent_FindFilterBadge = (FindFilterBadge);

// EXTERNAL MODULE: ./client/swaggerClient.ts + 11 modules
var swaggerClient = __webpack_require__(84160);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/capitalize.js
var capitalize = __webpack_require__(36622);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DoubleArrow.js
var DoubleArrow = __webpack_require__(5499);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Checkbox/Checkbox.js + 4 modules
var Checkbox = __webpack_require__(75158);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(81284);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(29894);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(61702);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(8519);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FindFilterMobileListItem.tsx
















var FindFilterMobileListItem = function(param) {
    var filters = param.filters, item = param.item, multiSelect = param.multiSelect, colors = param.colors, pageUrl = param.pageUrl, mmbr = param.mmbr, closeSubmenu = param.closeSubmenu;
    var ref;
    var ref1 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref1.partnerSiteFull, templatePath = ref1.templatePath;
    var ref2;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref2 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref2 !== void 0 ? ref2 : "AutoraTemplate") : templatePath;
    var FindMobileListItemButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindMobileListItemButton;
            });
        });
    }, [
        path
    ]);
    var handleClose = function() {
        setTimeout(function() {
            closeSubmenu && closeSubmenu();
        }, 1000);
        console.log("FindFilterMobileListItem: handleClose");
    };
    var _selected;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                disablePadding: true,
                secondaryAction: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    children: [
                        "(",
                        item.count,
                        ")"
                    ]
                }),
                sx: {
                    display: "inline-block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: multiSelect ? pageUrl : filterUrl(filters, item, undefined, pageUrl, mmbr),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindMobileListItemButton, {
                            selected: item.selected,
                            selectedcolor: colors.mainColor,
                            onClick: function() {
                                return !multiSelect ? handleClose() : undefined;
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                    children: multiSelect ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                        checked: (_selected = item.selected) !== null && _selected !== void 0 ? _selected : false,
                                        inputProps: {
                                            "aria-label": item === null || item === void 0 ? void 0 : item.title
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                        name: "options",
                                        checked: item.selected,
                                        value: item.selected,
                                        inputProps: {
                                            "aria-label": item === null || item === void 0 ? void 0 : item.title
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                    primary: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        fontSize: "16px",
                                        children: [
                                            (0,capitalize/* default */.Z)(item.title),
                                            " ",
                                            item.text ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                component: "span",
                                                display: "inline-block",
                                                fontSize: "11px",
                                                children: [
                                                    "(",
                                                    item.text,
                                                    ")"
                                                ]
                                            }) : null
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var FindComponent_FindFilterMobileListItem = (FindFilterMobileListItem);

;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterCategory.tsx











var FilterCategory = function(param) {
    var filters = param.filters, colors = param.colors, pageUrl = param.pageUrl, mmbr = param.mmbr, isMobile = param.isMobile, closeSubmenu = param.closeSubmenu;
    var ref, ref1, ref2, ref3;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref4.partnerSiteFull, templatePath = ref4.templatePath;
    var ref5;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref5 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref5 !== void 0 ? ref5 : "AutoraTemplate") : templatePath;
    var FindFilterCategoryList = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindFilterCategoryList;
            });
        });
    }, [
        path
    ]);
    var FindFilterCategoryListItem = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindFilterCategoryListItem;
            });
        });
    }, [
        path
    ]);
    var allCategories = (filters === null || filters === void 0 ? void 0 : (ref1 = filters.items) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
        return item.selected;
    })) ? false : true;
    var ref6, ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: filters === null || filters === void 0 ? void 0 : (ref2 = filters.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindFilterMobileListItem, {
                    filters: filters,
                    item: item,
                    multiSelect: false,
                    colors: colors,
                    pageUrl: pageUrl,
                    mmbr: mmbr,
                    closeSubmenu: closeSubmenu
                }, i);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindFilterCategoryList, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFilterCategoryListItem, {
                    disablePadding: true,
                    color: colors.mainColor,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: (ref6 = filterUrl(filters, undefined, filters.resetUrl, pageUrl, mmbr)) !== null && ref6 !== void 0 ? ref6 : router.asPath,
                        scroll: false,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: allCategories ? "selected" : undefined,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DoubleArrow/* default */.Z, {}),
                                " \xd6sszes kateg\xf3ria"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFilterCategoryListItem, {
                    subitem: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFilterCategoryList, {
                        disablePadding: true,
                        children: filters === null || filters === void 0 ? void 0 : (ref3 = filters.items) === null || ref3 === void 0 ? void 0 : ref3.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFilterCategoryListItem, {
                                disablePadding: true,
                                color: colors.mainColor,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: (ref7 = filterUrl(filters, item, undefined, pageUrl, mmbr)) !== null && ref7 !== void 0 ? ref7 : router.asPath,
                                    scroll: false,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: item.selected ? "selected" : undefined,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DoubleArrow/* default */.Z, {}),
                                            " ",
                                            (0,capitalize/* default */.Z)(item.title),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "(",
                                                    item.count,
                                                    ")"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, i);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FilterTypes_FilterCategory = (FilterCategory);

;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterCheckBox.tsx









var FilterCheckBox = function(param) {
    var filters = param.filters, pageUrl = param.pageUrl, mmbr = param.mmbr, colors = param.colors;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref1.partnerSiteFull, templatePath = ref1.templatePath;
    var ref2;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref2 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref2 !== void 0 ? ref2 : "AutoraTemplate") : templatePath;
    var FindCheckboxIcon = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindCheckboxIcon;
            });
        });
    }, [
        path
    ]);
    var FindCheckboxCheckedIcon = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindCheckboxCheckedIcon;
            });
        });
    }, [
        path
    ]);
    var handleChecked = function(e) {
        if (e.target.checked) {
            router.push(filterUrl(filters, undefined, filters.targetUrl, pageUrl, mmbr), undefined, {
                scroll: false
            });
        } else {
            router.push(filterUrl(filters, undefined, filters.resetUrl, pageUrl, mmbr), undefined, {
                scroll: false
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
            sx: {
                padding: 0
            },
            disableRipple: true,
            checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindCheckboxCheckedIcon, {
                checkedcolor: colors.mainColor
            }),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindCheckboxIcon, {}),
            onChange: handleChecked,
            inputProps: {
                "aria-label": filters === null || filters === void 0 ? void 0 : filters.title
            }
        })
    });
};
/* harmony default export */ var FilterTypes_FilterCheckBox = (FilterCheckBox);

;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterDropDown.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 







var FilterDropDown = function(param) {
    var filters = param.filters, mmbr = param.mmbr, pageUrl = param.pageUrl, isMobile = param.isMobile;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref2.partnerSiteFull, templatePath = ref2.templatePath;
    var ref3 = (0,react.useState)(""), localUrl = ref3[0], setLocalUrl = ref3[1];
    var ref4;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref4 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref4 !== void 0 ? ref4 : "AutoraTemplate") : templatePath;
    var FindSelect = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindSelect;
            });
        });
    }, [
        path
    ]);
    var FindSelectOption = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindSelectOption;
            });
        });
    }, [
        path
    ]);
    (0,react.useEffect)(function() {
        var ref;
        filters === null || filters === void 0 ? void 0 : (ref = filters.items) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return item.selected ? setLocalUrl(filterUrl(filters, item, undefined, pageUrl, mmbr)) : "";
        });
    }, []);
    var handleSelectChange = function(e) {
        var url = e.target.value;
        setLocalUrl(url);
        router.push(url, undefined, {
            scroll: false
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        m: isMobile ? 2 : undefined,
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSelect, {
            onChange: handleSelectChange,
            value: localUrl,
            children: filters === null || filters === void 0 ? void 0 : (ref1 = filters.items) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSelectOption, {
                    value: filterUrl(filters, item, undefined, pageUrl, mmbr),
                    children: item.title
                }, i);
            })
        })
    });
};
/* harmony default export */ var FilterTypes_FilterDropDown = (FilterDropDown);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Search.js
var Search = __webpack_require__(42761);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterFindQuery.tsx










var FilterFindQuery = function(param) {
    var filters = param.filters, colors = param.colors, mmbr = param.mmbr, pageUrl = param.pageUrl, isMobile = param.isMobile;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref1.partnerSiteFull, templatePath = ref1.templatePath;
    var ref2 = (0,react.useState)(""), searchQuery = ref2[0], setSearchQuery = ref2[1];
    var ref3 = (0,react.useState)(), searchTimeout = ref3[0], setSearchTimeout = ref3[1];
    var ref4 = (0,react.useReducer)(function(x) {
        return x + 1;
    }, 0), forceUpdate = ref4[1];
    var t = (0,es/* useTranslation */.$G)().t;
    var ref5;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref5 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref5 !== void 0 ? ref5 : "AutoraTemplate") : templatePath;
    var FindInput = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindInput;
            });
        });
    }, [
        path
    ]);
    var FindButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindButton;
            });
        });
    }, [
        path
    ]);
    var handleSearchOnKeyUp = function() {
        clearTimeout(searchTimeout);
        var timeout = setTimeout(function() {
            handleSearch();
        }, 2000);
        setSearchTimeout(timeout);
    };
    var handleSearch = function(e) {
        var ref;
        if (e !== undefined && e.type === "keydown" && e.key !== "Enter") return;
        var url = filters === null || filters === void 0 ? void 0 : (ref = filters.targetUrl) === null || ref === void 0 ? void 0 : ref.replace("{value}", searchQuery !== null && searchQuery !== void 0 ? searchQuery : "");
        router.push(filterUrl(filters, undefined, url, pageUrl, mmbr));
    };
    (0,react.useEffect)(function() {
        setSearchQuery((filters === null || filters === void 0 ? void 0 : filters.defaultValues) ? filters === null || filters === void 0 ? void 0 : filters.defaultValues[0] : "");
        forceUpdate();
    }, [
        filters === null || filters === void 0 ? void 0 : filters.defaultValues
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: isMobile ? "center" : undefined,
            my: isMobile ? 2 : undefined,
            columnSpacing: !isMobile ? 1 : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: isMobile ? 10 : true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindInput, {
                        type: "text",
                        placeholder: t("web.listing.filter.find.inputPlaceholder"),
                        value: searchQuery,
                        onChange: function(e) {
                            return setSearchQuery(e.target.value);
                        },
                        onKeyDown: handleSearch,
                        onKeyUp: isMobile ? handleSearchOnKeyUp : undefined,
                        fullWidth: true,
                        autoComplete: "off"
                    })
                }),
                !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                        bgcolor: colors.mainColor,
                        bghovercolor: colors.secondaryColor,
                        onClick: function() {
                            return handleSearch();
                        },
                        variant: "contained",
                        inputbutton: 1,
                        "aria-label": "Keres\xe9s",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                            fontSize: "large"
                        })
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var FilterTypes_FilterFindQuery = (FilterFindQuery);

// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterLongInterval.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 









var FilterLongInterval = function(param) {
    var filters = param.filters, colors = param.colors, pageUrl = param.pageUrl, mmbr = param.mmbr, isMobile = param.isMobile;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref1.partnerSiteFull, templatePath = ref1.templatePath;
    var ref2 = (0,react.useState)((filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin) !== undefined ? filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin : undefined), minValue = ref2[0], setMinValue = ref2[1];
    var ref3 = (0,react.useState)((filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax) !== undefined ? filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax : undefined), maxValue = ref3[0], setMaxValue = ref3[1];
    var ref4 = (0,react.useState)(), longIntervalSearchTimeout = ref4[0], setLongIntervalSearchTimeout = ref4[1];
    var hasMinValue = minValue !== undefined;
    var hasMaxValue = maxValue !== undefined;
    var hasOneValue = hasMinValue || hasMaxValue;
    var ref5;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref5 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref5 !== void 0 ? ref5 : "AutoraTemplate") : templatePath;
    var FindInput = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindInput;
            });
        });
    }, [
        path
    ]);
    var FindButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindButton;
            });
        });
    }, [
        path
    ]);
    var handleLongIntervalSearchOnKeyUp = function() {
        clearTimeout(longIntervalSearchTimeout);
        var longIntervalTimeout = setTimeout(function() {
            handleLongIntervalSearch();
        }, 2000);
        setLongIntervalSearchTimeout(longIntervalTimeout);
    };
    var handleLongIntervalSearch = function(e) {
        var ref;
        if (e !== undefined && e.type === "keydown" && e.key !== "Enter") return;
        var url = filters === null || filters === void 0 ? void 0 : (ref = filters.targetUrl) === null || ref === void 0 ? void 0 : ref.replace("(min)", hasMinValue ? minValue.toString() : "");
        url = url === null || url === void 0 ? void 0 : url.replace("(max)", hasMaxValue ? maxValue.toString() : "");
        router.push(hasOneValue ? filterUrl(filters, undefined, url, pageUrl, mmbr) : filters.resetUrl, undefined, {
            scroll: false
        });
    };
    var handleChangeMinVal = function(e) {
        var value = e.target.value.replace(/\s/g, "");
        value = value.replace(",", ".");
        setMinValue(parseFloat(value));
    };
    var handleChangeMaxVal = function(e) {
        var value = e.target.value.replace(/\s/g, "");
        value = value.replace(",", ".");
        var maxValue = !Number.isNaN(parseFloat(value)) ? parseFloat(value) : undefined;
        setMaxValue(maxValue);
    };
    (0,react.useEffect)(function() {
        setMinValue(filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin);
        setMaxValue(filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax);
    }, [
        filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin,
        filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            display: "flex",
            flexDirection: "row",
            justifyContent: isMobile ? "center" : undefined,
            m: isMobile ? 2 : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    mr: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                        customInput: FindInput,
                        placeholder: "-t\xf3l",
                        value: minValue !== null && minValue !== void 0 ? minValue : "",
                        onChange: handleChangeMinVal,
                        onKeyDown: handleLongIntervalSearch,
                        onKeyUp: isMobile ? handleLongIntervalSearchOnKeyUp : undefined,
                        autoComplete: "off",
                        thousandSeparator: " "
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    mr: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                        customInput: FindInput,
                        placeholder: "-ig",
                        value: maxValue !== null && maxValue !== void 0 ? maxValue : "",
                        onChange: handleChangeMaxVal,
                        onKeyDown: handleLongIntervalSearch,
                        onKeyUp: isMobile ? handleLongIntervalSearchOnKeyUp : undefined,
                        autoComplete: "off",
                        thousandSeparator: " ",
                        decimalSeparator: ","
                    })
                }),
                !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                        bgcolor: colors.mainColor,
                        bghovercolor: colors.secondaryColor,
                        onClick: function() {
                            return handleLongIntervalSearch();
                        },
                        variant: "contained",
                        inputbutton: 1,
                        "aria-label": "Keres\xe9s",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                            fontSize: "large"
                        })
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var FilterTypes_FilterLongInterval = (FilterLongInterval);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/OpenInFull.js
var OpenInFull = __webpack_require__(9137);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CloseFullscreen.js
var CloseFullscreen = __webpack_require__(61274);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterOptions.tsx












var FilterOptions = function(param) {
    var filters = param.filters, colors = param.colors, pageUrl = param.pageUrl, mmbr = param.mmbr, isMobile = param.isMobile, closeSubmenu = param.closeSubmenu;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref7.partnerSiteFull, templatePath = ref7.templatePath;
    var ref8;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref8 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref8 !== void 0 ? ref8 : "AutoraTemplate") : templatePath;
    var FindButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindButton;
            });
        });
    }, [
        path
    ]);
    var FindExpandLink = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindExpandLink;
            });
        });
    }, [
        path
    ]);
    var ref9 = (0,react.useState)(false), showAll = ref9[0], setShowAll = ref9[1];
    var length = (filters === null || filters === void 0 ? void 0 : filters.items) && (filters === null || filters === void 0 ? void 0 : (ref1 = filters.items) === null || ref1 === void 0 ? void 0 : ref1.length) > MAX_FILTER_SHOW ? MAX_FILTER_SHOW : filters === null || filters === void 0 ? void 0 : (ref2 = filters.items) === null || ref2 === void 0 ? void 0 : ref2.length;
    var maxLength = showAll ? filters === null || filters === void 0 ? void 0 : (ref3 = filters.items) === null || ref3 === void 0 ? void 0 : ref3.length : length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: filters === null || filters === void 0 ? void 0 : (ref4 = filters.items) === null || ref4 === void 0 ? void 0 : ref4.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindFilterMobileListItem, {
                    filters: filters,
                    item: item,
                    colors: colors,
                    pageUrl: pageUrl,
                    mmbr: mmbr,
                    closeSubmenu: closeSubmenu
                }, i);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                filters === null || filters === void 0 ? void 0 : (ref5 = filters.items) === null || ref5 === void 0 ? void 0 : ref5.slice(0, maxLength).map(function(item, i) {
                    return item.disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindButton, {
                        bgcolor: colors.mainColor,
                        bghovercolor: colors.secondaryColor,
                        variant: "outlined",
                        filterbutton: 1,
                        selected: (item === null || item === void 0 ? void 0 : item.selected) ? 1 : 0,
                        disabled: item.disabled,
                        "aria-label": item.title,
                        children: [
                            item.title,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "(",
                                    item.count,
                                    ")"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: filterUrl(filters, item, undefined, pageUrl, mmbr),
                        scroll: false,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindButton, {
                                bgcolor: colors.mainColor,
                                bghovercolor: colors.secondaryColor,
                                variant: "outlined",
                                filterbutton: 1,
                                selected: (item === null || item === void 0 ? void 0 : item.selected) ? 1 : 0,
                                "aria-label": item.title,
                                children: [
                                    item.title,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "(",
                                            item.count,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        })
                    }, i);
                }),
                (filters === null || filters === void 0 ? void 0 : filters.items) && (filters === null || filters === void 0 ? void 0 : (ref6 = filters.items) === null || ref6 === void 0 ? void 0 : ref6.length) > MAX_FILTER_SHOW ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindExpandLink, {
                    component: "span",
                    onClick: function() {
                        return setShowAll(!showAll);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        display: "inline-flex",
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                mr: 1,
                                children: showAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseFullscreen/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInFull/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: showAll ? "Mutass kevesebbet" : "Mutasd mindet"
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var FilterTypes_FilterOptions = (FilterOptions);

;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterCondition.tsx










var FilterCondition = function(param) {
    var filters = param.filters, colors = param.colors, pageUrl = param.pageUrl, mmbr = param.mmbr, isMobile = param.isMobile;
    var ref, ref1;
    var ref2 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref2.partnerSiteFull, templatePath = ref2.templatePath;
    var theme = (0,useTheme/* default */.Z)();
    var ref3;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref3 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref3 !== void 0 ? ref3 : "AutoraTemplate") : templatePath;
    var FindButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindButton;
            });
        });
    }, [
        path
    ]);
    var isFull = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("xl"));
    var _selected, _selected1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            container: true,
            display: "flex",
            alignItems: "center",
            justifyContent: isMobile ? "center" : "space-between",
            gap: 1,
            flexWrap: "nowrap",
            flexDirection: "row",
            margin: "auto",
            children: filters === null || filters === void 0 ? void 0 : (ref1 = filters.items) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    width: isMobile ? 100 : "100%",
                    children: item.disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                        variant: "outlined",
                        bgcolor: colors.mainColor,
                        bghovercolor: colors.secondaryColor,
                        conditionbutton: 1,
                        selected: Number((_selected = item.selected) !== null && _selected !== void 0 ? _selected : 0),
                        fullWidth: isFull,
                        sx: {
                            width: "100%"
                        },
                        disabled: item.disabled,
                        "aria-label": item.title,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            flexWrap: "wrap",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    flexWrap: "nowrap",
                                    fontSize: {
                                        xs: 12,
                                        md: 10,
                                        lg: 12
                                    },
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    flexWrap: "nowrap",
                                    fontSize: {
                                        xs: 11,
                                        md: 8,
                                        lg: 11
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "(",
                                            item.count,
                                            ")"
                                        ]
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: filterUrl(filters, item, undefined, pageUrl, mmbr),
                        scroll: false,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                                variant: "outlined",
                                bgcolor: colors.mainColor,
                                bghovercolor: colors.secondaryColor,
                                conditionbutton: 1,
                                selected: Number((_selected1 = item.selected) !== null && _selected1 !== void 0 ? _selected1 : 0),
                                fullWidth: isFull,
                                sx: {
                                    width: "100%"
                                },
                                disabled: item.disabled,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    flexWrap: "wrap",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            flexWrap: "nowrap",
                                            fontSize: {
                                                xs: 12,
                                                md: 10,
                                                lg: 12
                                            },
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            flexWrap: "nowrap",
                                            fontSize: {
                                                xs: 11,
                                                md: 8,
                                                lg: 11
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "(",
                                                    item.count,
                                                    ")"
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }, i);
            })
        })
    });
};
/* harmony default export */ var FilterTypes_FilterCondition = (FilterCondition);

;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterRadioButtons.tsx









var FilterRadioButtons = function(param) {
    var filters = param.filters, colors = param.colors, pageUrl = param.pageUrl, mmbr = param.mmbr, isMobile = param.isMobile, closeSubmenu = param.closeSubmenu;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref3.partnerSiteFull, templatePath = ref3.templatePath;
    var ref4;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref4 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref4 !== void 0 ? ref4 : "AutoraTemplate") : templatePath;
    var FindFormControlLabel = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindFormControlLabel;
            });
        });
    }, [
        path
    ]);
    var FindRadioButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindRadioButton;
            });
        });
    }, [
        path
    ]);
    var titleFormatter = function(title, count) {
        var splitted = title.split("-");
        var hasSecond = Boolean(splitted[1]);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            container: true,
            spacing: 1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: hasSecond ? "auto" : 11,
                    children: splitted[0]
                }),
                hasSecond ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: "auto",
                            children: "-"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: splitted[1]
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "filter-count",
                        children: [
                            "(",
                            count,
                            ")"
                        ]
                    })
                })
            ]
        });
    };
    var handleRadioChange = function(e) {
        var url = e.target.value;
        router.push(filterUrl(filters, undefined, url, pageUrl, mmbr), undefined, {
            scroll: false
        });
    };
    var _selected, _disabled;
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filters === null || filters === void 0 ? void 0 : (ref1 = filters.items) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindFilterMobileListItem, {
                filters: filters,
                item: item,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                closeSubmenu: closeSubmenu
            }, i);
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filters === null || filters === void 0 ? void 0 : (ref2 = filters.items) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, i) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(FindFormControlLabel, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindRadioButton, {
                    size: "small",
                    checked: (_selected = item.selected) !== null && _selected !== void 0 ? _selected : false,
                    disabled: (_disabled = item.disabled) !== null && _disabled !== void 0 ? _disabled : false,
                    value: item.targetUrl,
                    onChange: handleRadioChange,
                    inputProps: {
                        "aria-label": item === null || item === void 0 ? void 0 : item.title
                    },
                    bgcolor: colors.mainColor
                }),
                label: titleFormatter(item.title, item.count)
            }, i);
        })
    });
};
/* harmony default export */ var FilterTypes_FilterRadioButtons = (FilterRadioButtons);

;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterSliderIntervalInteger.tsx









var FilterSliderIntervalInteger = function(param) {
    var filters = param.filters, pageUrl = param.pageUrl, mmbr = param.mmbr, isMobile = param.isMobile;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref1.partnerSiteFull, templatePath = ref1.templatePath;
    var ref2 = (0,react.useState)((filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin) !== undefined ? filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin : undefined), minValue = ref2[0], setMinValue = ref2[1];
    var ref3 = (0,react.useState)((filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax) !== undefined ? filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax : undefined), maxValue = ref3[0], setMaxValue = ref3[1];
    var ref4;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref4 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref4 !== void 0 ? ref4 : "AutoraTemplate") : templatePath;
    var FindSlider = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindSlider;
            });
        });
    }, [
        path
    ]);
    var handleChangeInterval = function(e, newValue) {
        console.log(newValue);
        if (Array.isArray(newValue)) {
            var _newValue = (0,_sliced_to_array/* default */.Z)(newValue, 2), newMin = _newValue[0], newMax = _newValue[1];
            setMinValue(newMin);
            setMaxValue(newMax);
        }
    };
    var handleSearch = function() {
        var url;
        if (minValue && minValue === (filters === null || filters === void 0 ? void 0 : filters.intervalMin) && maxValue && maxValue === (filters === null || filters === void 0 ? void 0 : filters.intervalMax)) {
            url = filters === null || filters === void 0 ? void 0 : filters.resetUrl;
        } else {
            var ref;
            url = filters === null || filters === void 0 ? void 0 : (ref = filters.targetUrl) === null || ref === void 0 ? void 0 : ref.replace("(min)", minValue ? minValue === (filters === null || filters === void 0 ? void 0 : filters.intervalMin) ? "" : minValue.toString() : "");
            url = url === null || url === void 0 ? void 0 : url.replace("(max)", maxValue ? maxValue === (filters === null || filters === void 0 ? void 0 : filters.intervalMax) ? "" : maxValue.toString() : "");
        }
        router.push(filterUrl(filters, undefined, url, pageUrl, mmbr), undefined, {
            scroll: false
        });
    };
    var generateMarks = function(min, max, count) {
        var diff = max - min;
        var localCount = diff <= count ? diff : count;
        if (diff <= 1) {
            return [
                {
                    value: min,
                    label: min.toString()
                },
                {
                    value: max,
                    label: max.toString()
                }
            ];
        }
        var step = diff / (localCount - 1);
        if (isNaN(step) || step === 0) {
            return [];
        }
        return Array.from({
            length: localCount
        }, function(_, index) {
            return {
                value: min + step * index,
                label: (min + step * index).toFixed(0)
            };
        });
    };
    var marks = generateMarks(filters === null || filters === void 0 ? void 0 : filters.intervalMin, filters === null || filters === void 0 ? void 0 : filters.intervalMax, 5);
    (0,react.useEffect)(function() {
        setMinValue(filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin);
        setMaxValue(filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax);
    }, [
        filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin,
        filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        width: "100%",
        px: isMobile ? 4 : 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSlider, {
            min: filters === null || filters === void 0 ? void 0 : filters.intervalMin,
            step: 1,
            max: filters === null || filters === void 0 ? void 0 : filters.intervalMax,
            value: [
                minValue !== null && minValue !== void 0 ? minValue : filters === null || filters === void 0 ? void 0 : filters.intervalMin,
                maxValue !== null && maxValue !== void 0 ? maxValue : filters === null || filters === void 0 ? void 0 : filters.intervalMax
            ],
            onChange: handleChangeInterval,
            onChangeCommitted: function() {
                return handleSearch();
            },
            marks: marks,
            valueLabelDisplay: "on",
            disabled: (filters === null || filters === void 0 ? void 0 : filters.intervalMin) === (filters === null || filters === void 0 ? void 0 : filters.intervalMax),
            disableSwap: true
        })
    });
};
/* harmony default export */ var FilterTypes_FilterSliderIntervalInteger = (FilterSliderIntervalInteger);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(22841);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormGroup/FormGroup.js + 1 modules
var FormGroup = __webpack_require__(22416);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterCheckboxList.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 










var FilterCheckBoxList = function(param) {
    var filters = param.filters, pageUrl = param.pageUrl, mmbr = param.mmbr, colors = param.colors, isMobile = param.isMobile;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref2.partnerSiteFull, templatePath = ref2.templatePath;
    var ref3 = (0,react.useState)(), list = ref3[0], setList = ref3[1];
    var ref4;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref4 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref4 !== void 0 ? ref4 : "AutoraTemplate") : templatePath;
    var FindCheckboxIcon = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindCheckboxIcon;
            });
        });
    }, [
        path
    ]);
    var FindCheckboxCheckedIcon = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindCheckboxCheckedIcon;
            });
        });
    }, [
        path
    ]);
    var handleChecked = function(e) {
        if (e.target.checked) {
            setList(function(prevList) {
                return prevList ? (0,_to_consumable_array/* default */.Z)(prevList).concat([
                    e.target.value
                ]) : [
                    e.target.value
                ];
            });
        } else {
            setList(function(prevList) {
                return prevList ? prevList.filter(function(item) {
                    return item !== e.target.value;
                }) : undefined;
            });
        }
    };
    (0,react.useEffect)(function() {
        var ref, ref1;
        var ref2;
        setList((ref2 = (ref1 = (ref = filters.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return item.selected;
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
            return item.targetUrlListItem;
        })) !== null && ref2 !== void 0 ? ref2 : []);
    }, [
        filters
    ]);
    (0,react.useEffect)(function() {
        if (list) {
            var ref;
            var url = (ref = filters.targetUrl) === null || ref === void 0 ? void 0 : ref.replace("(list)", list.join(","));
            router.push(list.length > 0 ? filterUrl(filters, undefined, url, pageUrl, mmbr) : filters.resetUrl, undefined, {
                scroll: false
            });
        }
    }, [
        list
    ]);
    var _targetUrlListItem, _selected, _disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* default */.Z, {
        sx: {
            p: isMobile ? 2 : undefined
        },
        children: (ref1 = filters.items) === null || ref1 === void 0 ? void 0 : ref1.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    sx: {
                        p: 0,
                        pr: 1
                    },
                    disableRipple: true,
                    checkedIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindCheckboxCheckedIcon, {
                        checkedcolor: colors.mainColor
                    }),
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindCheckboxIcon, {}),
                    value: (_targetUrlListItem = item.targetUrlListItem) !== null && _targetUrlListItem !== void 0 ? _targetUrlListItem : "",
                    onChange: handleChecked,
                    checked: (_selected = item.selected) !== null && _selected !== void 0 ? _selected : false,
                    disabled: (_disabled = item.disabled) !== null && _disabled !== void 0 ? _disabled : false
                }),
                label: item.title,
                sx: {
                    mb: 1
                }
            }, i);
        })
    });
};
/* harmony default export */ var FilterCheckboxList = (FilterCheckBoxList);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(55343);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Clear.js
var Clear = __webpack_require__(63343);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterIntervalDropDown.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 











var FilterIntervalDropDownName;
(function(FilterIntervalDropDownName) {
    FilterIntervalDropDownName["Min"] = "min";
    FilterIntervalDropDownName["Max"] = "max";
})(FilterIntervalDropDownName || (FilterIntervalDropDownName = {}));
var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var MenuProps = function(isMobile) {
    return {
        style: {
            zIndex: 11000
        },
        PaperProps: {
            style: {
                maxHeight: isMobile ? "70%" : ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
            }
        }
    };
};
var FilterIntervalDropdown = function(param) {
    var filters = param.filters, mmbr = param.mmbr, pageUrl = param.pageUrl, isMobile = param.isMobile;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref3.partnerSiteFull, templatePath = ref3.templatePath;
    var ref4 = (0,react.useState)((filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin) !== undefined ? filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMin.toString() : undefined), minValue = ref4[0], setMinValue = ref4[1];
    var ref5 = (0,react.useState)((filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax) !== undefined ? filters === null || filters === void 0 ? void 0 : filters.intervalSelectedMax.toString() : undefined), maxValue = ref5[0], setMaxValue = ref5[1];
    var ref6;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref6 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref6 !== void 0 ? ref6 : "AutoraTemplate") : templatePath;
    var FindMuiSelect = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindMuiSelect;
            });
        });
    }, [
        path
    ]);
    var FindMuiSelectMenuItem = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindMuiSelectMenuItem;
            });
        });
    }, [
        path
    ]);
    (0,react.useEffect)(function() {
        if (filters.intervalSelectedMin !== undefined && filters.intervalSelectedMax !== undefined) {
            var minNum = parseInt(filters.intervalSelectedMin.toString());
            var maxNum = parseInt(filters.intervalSelectedMax.toString());
            if (minNum > maxNum) {
                var ref;
                setMinValue(maxNum.toString());
                setMaxValue(minNum.toString());
                var url = (ref = filters.targetUrl) === null || ref === void 0 ? void 0 : ref.replace("(min)", maxNum.toString()).replace("(max)", minNum.toString());
                router.push(filterUrl(filters, undefined, url, pageUrl, mmbr), undefined, {
                    scroll: false
                });
            }
        }
    }, [
        filters.intervalSelectedMin,
        filters.intervalSelectedMax
    ]);
    var handleChangeMinValue = function(e) {
        var ref;
        var target = e.target;
        var newMinValue = target.value;
        setMinValue(newMinValue);
        var newMaxValue = maxValue;
        if (newMinValue !== "" && maxValue !== "" && parseInt(newMinValue) > parseInt(maxValue)) {
            newMaxValue = newMinValue;
            setMaxValue(newMinValue);
        }
        var isEmpty = newMinValue === "" && (newMaxValue === "" || newMaxValue === undefined);
        var url = (ref = filters.targetUrl) === null || ref === void 0 ? void 0 : ref.replace("(min)", newMinValue !== null && newMinValue !== void 0 ? newMinValue : "").replace("(max)", newMaxValue !== null && newMaxValue !== void 0 ? newMaxValue : "");
        router.push(!isEmpty ? filterUrl(filters, undefined, url, pageUrl, mmbr) : filters.resetUrl, undefined, {
            scroll: false
        });
    };
    var handleChangeMaxValue = function(e) {
        var ref;
        var target = e.target;
        var newMaxValue = target.value;
        setMaxValue(newMaxValue);
        var newMinValue = minValue;
        if (newMaxValue !== "" && minValue !== "" && parseInt(newMaxValue) < parseInt(minValue)) {
            newMinValue = newMaxValue;
            setMinValue(newMaxValue);
        }
        var isEmpty = newMaxValue === "" && (newMinValue === "" || newMinValue === undefined);
        var url = (ref = filters.targetUrl) === null || ref === void 0 ? void 0 : ref.replace("(min)", newMinValue !== null && newMinValue !== void 0 ? newMinValue : "").replace("(max)", newMaxValue !== null && newMaxValue !== void 0 ? newMaxValue : "");
        router.push(!isEmpty ? filterUrl(filters, undefined, url, pageUrl, mmbr) : filters.resetUrl, undefined, {
            scroll: false
        });
    };
    var filteredMinItems = (0,react.useMemo)(function() {
        var ref;
        if (!maxValue) return filters.items;
        return (ref = filters.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return parseInt(item.targetUrlListItem) <= parseInt(maxValue);
        });
    }, [
        filters.items,
        maxValue
    ]);
    var filteredMaxItems = (0,react.useMemo)(function() {
        var ref;
        if (!minValue) return filters.items;
        return (ref = filters.items) === null || ref === void 0 ? void 0 : ref.filter(function(item) {
            return parseInt(item.targetUrlListItem) >= parseInt(minValue);
        });
    }, [
        filters.items,
        minValue
    ]);
    var ref7;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        direction: "row",
        gap: 1,
        width: "100%",
        px: isMobile ? 3 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindMuiSelect, {
                    size: "small",
                    name: FilterIntervalDropDownName.Min,
                    value: (ref7 = minValue !== null && minValue !== void 0 ? minValue : (ref1 = filters.intervalSelectedMin) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref7 !== void 0 ? ref7 : "",
                    onChange: handleChangeMinValue,
                    displayEmpty: true,
                    endAdornment: minValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        sx: {
                            mr: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            size: "small",
                            edge: "end",
                            onClick: function() {
                                return handleChangeMinValue({
                                    target: {
                                        name: FilterIntervalDropDownName.Min,
                                        value: ""
                                    }
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {
                                sx: {
                                    fontSize: 15
                                }
                            })
                        })
                    }) : null,
                    MenuProps: MenuProps(isMobile),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMuiSelectMenuItem, {
                            value: "",
                            children: "-t\xf3l"
                        }),
                        filteredMinItems === null || filteredMinItems === void 0 ? void 0 : filteredMinItems.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMuiSelectMenuItem, {
                                value: item.targetUrlListItem,
                                children: item.title
                            }, i);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                fullWidth: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindMuiSelect, {
                    size: "small",
                    name: FilterIntervalDropDownName.Max,
                    value: maxValue ? maxValue : filters.intervalSelectedMax ? (ref2 = filters.intervalSelectedMax) === null || ref2 === void 0 ? void 0 : ref2.toString() : "",
                    onChange: handleChangeMaxValue,
                    displayEmpty: true,
                    endAdornment: maxValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        sx: {
                            mr: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            size: "small",
                            edge: "end",
                            onClick: function() {
                                return handleChangeMaxValue({
                                    target: {
                                        name: FilterIntervalDropDownName.Max,
                                        value: ""
                                    }
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Clear/* default */.Z, {
                                sx: {
                                    fontSize: 15
                                }
                            })
                        })
                    }) : null,
                    MenuProps: MenuProps(isMobile),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMuiSelectMenuItem, {
                            value: "",
                            children: "-ig"
                        }),
                        filteredMaxItems === null || filteredMaxItems === void 0 ? void 0 : filteredMaxItems.map(function(item, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMuiSelectMenuItem, {
                                value: item.targetUrlListItem,
                                children: item.title
                            }, i);
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var FilterIntervalDropDown = (FilterIntervalDropdown);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Remove.js
var Remove = __webpack_require__(94895);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterOptionsMultiselect.tsx















var getUrl = function(filters, item, pageUrl, mmbr) {
    var ref, ref1;
    var list = (ref = filters.items) === null || ref === void 0 ? void 0 : ref.filter(function(i) {
        return i.selected;
    }).map(function(i) {
        return i.targetUrlListItem;
    });
    if (item.selected) {
        list = list === null || list === void 0 ? void 0 : list.filter(function(i) {
            return i !== item.targetUrlListItem;
        });
    } else {
        list = list ? (0,_to_consumable_array/* default */.Z)(list).concat([
            item.targetUrlListItem
        ]) : [
            item.targetUrlListItem
        ];
    }
    var url = list && list.length > 0 ? (ref1 = filters.targetUrl) === null || ref1 === void 0 ? void 0 : ref1.replace("(list)", list === null || list === void 0 ? void 0 : list.join(",")) : filters.resetUrl;
    return filterUrl(filters, undefined, url, pageUrl, mmbr);
};
var FilterOptionsMultiselect = function(param) {
    var filters = param.filters, colors = param.colors, pageUrl = param.pageUrl, mmbr = param.mmbr, isMobile = param.isMobile, closeSubmenu = param.closeSubmenu;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref7.partnerSiteFull, templatePath = ref7.templatePath;
    var ref8;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref8 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref8 !== void 0 ? ref8 : "AutoraTemplate") : templatePath;
    var FindButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindButton;
            });
        });
    }, [
        path
    ]);
    var FindExpandLink = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindExpandLink;
            });
        });
    }, [
        path
    ]);
    var ref9 = (0,react.useState)(false), showAll = ref9[0], setShowAll = ref9[1];
    var length = (filters === null || filters === void 0 ? void 0 : filters.items) && (filters === null || filters === void 0 ? void 0 : (ref1 = filters.items) === null || ref1 === void 0 ? void 0 : ref1.length) > MAX_FILTER_SHOW ? MAX_FILTER_SHOW : filters === null || filters === void 0 ? void 0 : (ref2 = filters.items) === null || ref2 === void 0 ? void 0 : ref2.length;
    var maxLength = showAll ? filters === null || filters === void 0 ? void 0 : (ref3 = filters.items) === null || ref3 === void 0 ? void 0 : ref3.length : length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: filters === null || filters === void 0 ? void 0 : (ref4 = filters.items) === null || ref4 === void 0 ? void 0 : ref4.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindFilterMobileListItem, {
                    filters: filters,
                    item: item,
                    multiSelect: true,
                    colors: colors,
                    pageUrl: getUrl(filters, item, pageUrl, mmbr),
                    mmbr: mmbr,
                    closeSubmenu: closeSubmenu
                }, i);
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                filters === null || filters === void 0 ? void 0 : (ref5 = filters.items) === null || ref5 === void 0 ? void 0 : ref5.slice(0, maxLength).map(function(item, i) {
                    return item.disabled ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindButton, {
                        bgcolor: colors.mainColor,
                        bghovercolor: colors.secondaryColor,
                        variant: "outlined",
                        filterbutton: 1,
                        selected: (item === null || item === void 0 ? void 0 : item.selected) ? 1 : 0,
                        multiselect: 1,
                        startIcon: item.selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {
                            fontSize: "small"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                            fontSize: "small"
                        }),
                        "aria-label": item.title,
                        children: [
                            item.title,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "(",
                                    item.count,
                                    ")"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: getUrl(filters, item, pageUrl, mmbr),
                        scroll: false,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindButton, {
                                bgcolor: colors.mainColor,
                                bghovercolor: colors.secondaryColor,
                                variant: "outlined",
                                filterbutton: 1,
                                selected: (item === null || item === void 0 ? void 0 : item.selected) ? 1 : 0,
                                multiselect: 1,
                                startIcon: item.selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {
                                    fontSize: "small"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {
                                    fontSize: "small"
                                }),
                                "aria-label": item.title,
                                children: [
                                    item.title,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "(",
                                            item.count,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        })
                    }, i);
                }),
                (filters === null || filters === void 0 ? void 0 : filters.items) && (filters === null || filters === void 0 ? void 0 : (ref6 = filters.items) === null || ref6 === void 0 ? void 0 : ref6.length) > MAX_FILTER_SHOW ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindExpandLink, {
                    onClick: function() {
                        return setShowAll(!showAll);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        display: "inline-flex",
                        flexDirection: "row",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                mr: 1,
                                children: showAll ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseFullscreen/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInFull/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                children: showAll ? "Mutass kevesebbet" : "Mutasd mindet"
                            })
                        ]
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var FilterTypes_FilterOptionsMultiselect = (FilterOptionsMultiselect);

;// CONCATENATED MODULE: ./components/_common/FindComponent/FilterTypes/FilterType.tsx














// Itt lehet beállítani hogy max ennyit filter opciót mutasson egyszerre, ha többb va
// akkor megjelenik egy gomb hogy mutass többet, ha 10 vagy kevesebb opció van
// akkor megjelenik mind
var MAX_FILTER_SHOW = 10;
var getFilterType = function(filters, colors, pageUrl, mmbr, isMobile, closeSubmenu) {
    switch(filters.uiMode){
        case swaggerClient/* ResultFilterUIMode.Options */.XTk.Options:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterOptions, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile,
                closeSubmenu: closeSubmenu
            });
        case swaggerClient/* ResultFilterUIMode.OptionsMultiselect */.XTk.OptionsMultiselect:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterOptionsMultiselect, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile,
                closeSubmenu: closeSubmenu
            });
        case swaggerClient/* ResultFilterUIMode.DropDown */.XTk.DropDown:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterDropDown, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile
            });
        case swaggerClient/* ResultFilterUIMode.FindQuery */.XTk.FindQuery:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterFindQuery, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile
            });
        case swaggerClient/* ResultFilterUIMode.CheckBox */.XTk.CheckBox:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterCheckBox, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile
            });
        case swaggerClient/* ResultFilterUIMode.LongInterval */.XTk.LongInterval:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterLongInterval, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile
            });
        case swaggerClient/* ResultFilterUIMode.Categories */.XTk.Categories:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterCategory, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile,
                closeSubmenu: closeSubmenu
            });
        case swaggerClient/* ResultFilterUIMode.UjVagyHasznalt */.XTk.UjVagyHasznalt:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterCondition, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile
            });
        case swaggerClient/* ResultFilterUIMode.RadioButtons */.XTk.RadioButtons:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterRadioButtons, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile,
                closeSubmenu: closeSubmenu
            });
        case swaggerClient/* ResultFilterUIMode.CheckboxList */.XTk.CheckboxList:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCheckboxList, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile
            });
        case swaggerClient/* ResultFilterUIMode.IntervalDropDown */.XTk.IntervalDropDown:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterIntervalDropDown, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile
            });
        case swaggerClient/* ResultFilterUIMode.SliderIntervalInteger */.XTk.SliderIntervalInteger:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterTypes_FilterSliderIntervalInteger, {
                filters: filters,
                colors: colors,
                pageUrl: pageUrl,
                mmbr: mmbr,
                isMobile: isMobile
            });
    }
};
/* harmony default export */ var FilterType = (getFilterType);

;// CONCATENATED MODULE: ./components/_common/FindComponent/FindFilterBlock.tsx









var FindFilterBlock = function(param) {
    var filters = param.filters, pageUrl = param.pageUrl, colors = param.colors;
    var ref;
    var router = (0,next_router.useRouter)();
    var mmbr = router.query.mmbr;
    var ref1 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref1.partnerSiteFull, templatePath = ref1.templatePath;
    var ref2;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref2 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref2 !== void 0 ? ref2 : "AutoraTemplate") : templatePath;
    var FindTitle = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindTitle;
            });
        });
    }, [
        path
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
        mb: 3,
        children: [
            filters.uiMode !== swaggerClient/* ResultFilterUIMode.CheckBox */.XTk.CheckBox ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindTitle, {
                children: [
                    filters.title,
                    " ",
                    filters.subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: filters.subtitle
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                display: "inline-flex",
                alignContent: "start",
                alignItems: "stretch",
                flexDirection: "row",
                flexWrap: "wrap",
                children: [
                    filters.uiMode === swaggerClient/* ResultFilterUIMode.CheckBox */.XTk.CheckBox ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindTitle, {
                        children: filters.title
                    }) : null,
                    FilterType(filters, colors, pageUrl, mmbr)
                ]
            })
        ]
    });
};
/* harmony default export */ var FindComponent_FindFilterBlock = (FindFilterBlock);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var styles_useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccessTime.js
var AccessTime = __webpack_require__(90244);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Room.js
var Room = __webpack_require__(71983);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalShipping.js
var LocalShipping = __webpack_require__(1645);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Email.js
var Email = __webpack_require__(50891);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ChevronRight.js
var ChevronRight = __webpack_require__(26215);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FavoriteBorder.js
var FavoriteBorder = __webpack_require__(91811);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ImageNotSupportedOutlined.js
var ImageNotSupportedOutlined = __webpack_require__(35956);
// EXTERNAL MODULE: ./utils/functions/enumTitles.ts
var enumTitles = __webpack_require__(28461);
// EXTERNAL MODULE: ./utils/contexts/RuntimeContext/RuntimeConfigContext.tsx + 1 modules
var RuntimeConfigContext = __webpack_require__(36797);
// EXTERNAL MODULE: ./utils/functions/imageURL.ts
var imageURL = __webpack_require__(33975);
// EXTERNAL MODULE: ./utils/functions/szalagImageUrls.ts
var szalagImageUrls = __webpack_require__(2521);
// EXTERNAL MODULE: ./utils/functions/priceFormatter.ts
var priceFormatter = __webpack_require__(60121);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(73707);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
;// CONCATENATED MODULE: ./hooks/useSessionStorage.ts


var useSessionStorage = function(key, initialValue) {
    var ref = (0,react.useState)(function() {
        try {
            var item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            console.error("Error loading from sessionStorage:", error);
            return initialValue;
        }
    }), storedValue = ref[0], setStoredValue = ref[1];
    var setValue = function(value) {
        try {
            if (value === null) {
                window.sessionStorage.removeItem(key);
            } else {
                var valueToStore = (0,_instanceof/* default */.Z)(value, Function) ? value(storedValue) : value;
                setStoredValue(valueToStore);
                window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
            }
        } catch (error) {
            console.error("Error saving to sessionStorage:", error);
        }
    };
    return [
        storedValue,
        setValue
    ];
};
/* harmony default export */ var hooks_useSessionStorage = (useSessionStorage);

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
;// CONCATENATED MODULE: ./components/_common/FindComponent/Find.styles.ts

var StyledLink = (0,styled/* default */.ZP)("a")(function() {
    return {
        overflow: "hidden",
        textOverflow: "ellipsis"
    };
});

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FindItem.tsx
/* eslint-disable @next/next/no-img-element */ 






























var separatedFact = function(fact) {
    var index = fact.indexOf(":");
    if (index !== -1) {
        var elsoElem = fact.substring(0, index);
        var masodikElem = fact.substring(index + 1);
        return "<i>".concat(elsoElem, ":</i> ").concat(masodikElem);
    } else {
        return fact;
    }
};
var FindItem = function(param) {
    var item = param.item, colors = param.colors, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _setFavButton = param.setFavButton, setFavButton = _setFavButton === void 0 ? true : _setFavButton, _isKiemelt = param.isKiemelt, isKiemelt = _isKiemelt === void 0 ? false : _isKiemelt, _isKiemeltFromLanding = param.isKiemeltFromLanding, isKiemeltFromLanding = _isKiemeltFromLanding === void 0 ? false : _isKiemeltFromLanding, _preload = param.preload, preload = _preload === void 0 ? false : _preload;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref10.partnerSiteFull, templatePath = ref10.templatePath;
    var runtimeConfig = (0,RuntimeConfigContext/* useRuntimeConfig */.BE)();
    var theme = (0,styles_useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref11 = (0,_sliced_to_array/* default */.Z)(hooks_useSessionStorage("listingScrollPosition", 0), 2), setListingScrollPosition = ref11[1];
    var ref12;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref12 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref12 !== void 0 ? ref12 : "AutoraTemplate") : templatePath;
    var type = templatePath;
    var FindButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindButton;
            });
        });
    }, [
        path
    ]);
    var FindItemContainer = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemContainer;
            });
        });
    }, [
        path
    ]);
    var FindItemDate = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemDate;
            });
        });
    }, [
        path
    ]);
    var FindItemDeliveryContainer = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemDeliveryContainer;
            });
        });
    }, [
        path
    ]);
    var FindItemDeliveryItem = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemDeliveryItem;
            });
        });
    }, [
        path
    ]);
    var FindItemFact = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemFact;
            });
        });
    }, [
        path
    ]);
    var FindItemImage = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemImage;
            });
        });
    }, [
        path
    ]);
    var FindItemNoImage = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemNoImage;
            });
        });
    }, [
        path
    ]);
    var FindItemPrice = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemPrice;
            });
        });
    }, [
        path
    ]);
    var FindItemText = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindItemText;
            });
        });
    }, [
        path
    ]);
    var FindTitle = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindTitle;
            });
        });
    }, [
        path
    ]);
    var FindSkeleton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindSkeleton;
            });
        });
    }, [
        path
    ]);
    var hasQuantity = Boolean(item === null || item === void 0 ? void 0 : (ref1 = item.price) === null || ref1 === void 0 ? void 0 : ref1.quantity);
    var hasFlags = Boolean(item === null || item === void 0 ? void 0 : (ref2 = item.price) === null || ref2 === void 0 ? void 0 : ref2.flags);
    var hasUrl = (item === null || item === void 0 ? void 0 : item.url) && (item === null || item === void 0 ? void 0 : item.url) !== "" || (item === null || item === void 0 ? void 0 : item.urlPP) && item.urlPP !== "";
    var hasDisplayedAt = item === null || item === void 0 ? void 0 : item.displayedAt;
    var hasSzalagKiemeles = (type === _app.PageType.SZP || type === _app.PageType.SZPPL) && (item === null || item === void 0 ? void 0 : item.kiemelesSzalag);
    var hasKeyFacts = (item === null || item === void 0 ? void 0 : item.keyFacts) && item.keyFacts.length > 0;
    var justOneKeyFact = (item === null || item === void 0 ? void 0 : item.keyFacts) && item.keyFacts.length === 1 ? 1 : 0;
    var hasText = (item === null || item === void 0 ? void 0 : item.text) && item.text !== "";
    var hasKeyFactsOrText = hasKeyFacts || hasText;
    var hasShipping = (item === null || item === void 0 ? void 0 : item.shippingFutar) || (item === null || item === void 0 ? void 0 : item.shippingPosta) || (item === null || item === void 0 ? void 0 : item.shippingSzemelyes);
    var imageUrl = isMobile ? (0,imageURL/* imageURL */.q)(runtimeConfig.BLOB_BASE_PATH, item === null || item === void 0 ? void 0 : item.imageUrlL) : (0,imageURL/* imageURL */.q)(runtimeConfig.BLOB_BASE_PATH, item === null || item === void 0 ? void 0 : item.imageUrlS);
    var handleSetPosition = function() {
        setListingScrollPosition(window.scrollY);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindItemContainer, {
            container: true,
            iskiemeltfromlanding: isKiemeltFromLanding ? 1 : 0,
            alignContent: "flex-start",
            sx: {
                backgroundColor: isKiemelt ? "".concat(theme.palette.primary.light, "7f") : undefined
            },
            height: isKiemeltFromLanding ? "100%" : undefined,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: isKiemeltFromLanding ? 12 : 3,
                    mb: isKiemeltFromLanding ? 0 : {
                        xs: 2,
                        lg: 0
                    },
                    alignSelf: isKiemeltFromLanding ? "start" : {
                        xs: "start",
                        lg: "center"
                    },
                    justifyContent: "center",
                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                        variant: "rectangular",
                        sx: {
                            margin: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemImage, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemNoImage, {
                                iskiemeltfromlanding: isKiemeltFromLanding ? 1 : 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    height: "100%",
                                    direction: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            mb: 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageNotSupportedOutlined/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                dangerouslySetInnerHTML: {
                                                    __html: t("common.noImage")
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }) : hasUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: type === _app.PageType.RBhuPP ? item === null || item === void 0 ? void 0 : item.urlPP : item === null || item === void 0 ? void 0 : item.url,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: function() {
                                return handleSetPosition();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindItemImage, {
                                iskiemeltfromlanding: isKiemeltFromLanding ? 1 : 0,
                                children: [
                                    hasSzalagKiemeles ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "ribbon ".concat(isKiemeltFromLanding ? "ribbon-kiemelt" : ""),
                                        src: (0,szalagImageUrls/* getSzalagImageUrl */.y)(item.kiemelesSzalag).ribbon,
                                        alt: t(enumTitles/* pfSzalagKiemelesVariantTitle */.C5[item.kiemelesSzalag])
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                    imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: imageUrl,
                                        alt: (0,capitalize/* default */.Z)(item === null || item === void 0 ? void 0 : item.title),
                                        layout: "fill",
                                        objectFit: "contain",
                                        loading: preload ? "eager" : "lazy",
                                        priority: preload
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemNoImage, {
                                        iskiemeltfromlanding: isKiemeltFromLanding ? 1 : 0,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            height: "100%",
                                            direction: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                    mb: 0,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageNotSupportedOutlined/* default */.Z, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        dangerouslySetInnerHTML: {
                                                            __html: t("common.noImage")
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindItemImage, {
                        iskiemeltfromlanding: isKiemeltFromLanding ? 1 : 0,
                        children: [
                            hasSzalagKiemeles ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "ribbon ".concat(isKiemeltFromLanding ? "ribbon-kiemelt" : ""),
                                src: (0,szalagImageUrls/* getSzalagImageUrl */.y)(item.kiemelesSzalag).ribbon,
                                alt: t(enumTitles/* pfSzalagKiemelesVariantTitle */.C5[item.kiemelesSzalag])
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                            imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: imageUrl,
                                alt: (0,capitalize/* default */.Z)(item === null || item === void 0 ? void 0 : item.title),
                                layout: "fill",
                                objectFit: "contain",
                                loading: preload ? "eager" : "lazy",
                                priority: preload
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemNoImage, {
                                iskiemeltfromlanding: isKiemeltFromLanding ? 1 : 0,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    height: "100%",
                                    direction: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            mb: 0,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageNotSupportedOutlined/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                dangerouslySetInnerHTML: {
                                                    __html: t("common.noImage")
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: isKiemeltFromLanding ? 12 : 9,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        height: "100%",
                        px: isKiemeltFromLanding ? 1 : 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: isKiemeltFromLanding ? 12 : 9,
                                display: "flex",
                                flexDirection: "column",
                                pl: isKiemeltFromLanding ? 1 : {
                                    xs: 1,
                                    sm: 2
                                },
                                order: isKiemeltFromLanding ? 2 : undefined,
                                children: [
                                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                        variant: "rectangular",
                                        height: 25,
                                        sx: {
                                            mb: 0.5
                                        }
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindTitle, {
                                        iskiemeltfromlanding: isKiemeltFromLanding ? 1 : 0,
                                        item: 1,
                                        children: hasUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: type === _app.PageType.RBhuPP ? item === null || item === void 0 ? void 0 : item.urlPP : item === null || item === void 0 ? void 0 : item.url,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                                onClick: function() {
                                                    return handleSetPosition();
                                                },
                                                children: (0,capitalize/* default */.Z)(item === null || item === void 0 ? void 0 : item.title)
                                            })
                                        }) : (0,capitalize/* default */.Z)(item === null || item === void 0 ? void 0 : item.title)
                                    }),
                                    hasDisplayedAt ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        container: true,
                                        mb: 0.5,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                                variant: "rectangular",
                                                sx: {
                                                    mb: 1
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindItemDate, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                            mr: 0.5,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccessTime/* default */.Z, {})
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                            children: moment_default()(item === null || item === void 0 ? void 0 : item.displayedAt).format("LLL")
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindItemDate, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                        mr: 0.5,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccessTime/* default */.Z, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                        children: moment_default()(item === null || item === void 0 ? void 0 : item.displayedAt).format("LLL")
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null,
                                    hasKeyFactsOrText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        container: true,
                                        children: [
                                            hasKeyFacts ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                mb: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                    display: "inline-block",
                                                    children: item === null || item === void 0 ? void 0 : (ref3 = item.keyFacts) === null || ref3 === void 0 ? void 0 : ref3.map(function(fact, i) {
                                                        return isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                                            variant: "rectangular",
                                                            sx: {
                                                                display: "inline-block",
                                                                mr: 0.5
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemFact, {
                                                                sepcolor: colors.mainColor,
                                                                dangerouslySetInnerHTML: {
                                                                    __html: separatedFact(fact)
                                                                }
                                                            })
                                                        }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemFact, {
                                                            sepcolor: colors.mainColor,
                                                            justonefact: justOneKeyFact,
                                                            dangerouslySetInnerHTML: {
                                                                __html: separatedFact(fact)
                                                            }
                                                        }, i);
                                                    })
                                                })
                                            }) : null,
                                            hasText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                mb: 1,
                                                children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                                    variant: "rectangular",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemText, {
                                                        dangerouslySetInnerHTML: {
                                                            __html: item.text
                                                        }
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemText, {
                                                    dangerouslySetInnerHTML: {
                                                        __html: item.text
                                                    }
                                                })
                                            }) : null
                                        ]
                                    }) : null,
                                    hasShipping ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        container: true,
                                        display: "flex",
                                        alignItems: "center",
                                        mt: "auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemDeliveryContainer, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        (item === null || item === void 0 ? void 0 : item.shippingSzemelyes) ? isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                                            variant: "rectangular",
                                                            width: 24,
                                                            height: 24,
                                                            sx: {
                                                                display: "inline-block",
                                                                mr: 0.5
                                                            }
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemDeliveryItem, {
                                                            color: "#5bc0de",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Room/* default */.Z, {
                                                                fontSize: "large"
                                                            })
                                                        }) : null,
                                                        (item === null || item === void 0 ? void 0 : item.shippingFutar) ? isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                                            variant: "rectangular",
                                                            width: 24,
                                                            height: 24,
                                                            sx: {
                                                                display: "inline-block",
                                                                mr: 0.5
                                                            }
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemDeliveryItem, {
                                                            color: "#d9534f",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalShipping/* default */.Z, {
                                                                fontSize: "large"
                                                            })
                                                        }) : null,
                                                        (item === null || item === void 0 ? void 0 : item.shippingPosta) ? isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                                            variant: "rectangular",
                                                            width: 24,
                                                            height: 24,
                                                            sx: {
                                                                display: "inline-block"
                                                            }
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemDeliveryItem, {
                                                            color: "#5cb85c",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Email/* default */.Z, {
                                                                fontSize: "large"
                                                            })
                                                        }) : null
                                                    ]
                                                })
                                            })
                                        })
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: isKiemeltFromLanding ? 12 : 3,
                                pl: 1,
                                pt: isKiemeltFromLanding ? 1 : {
                                    xs: 1,
                                    sm: 0
                                },
                                order: isKiemeltFromLanding ? 1 : undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    direction: "row",
                                    height: "100%",
                                    alignItems: isKiemeltFromLanding ? "end" : undefined,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: isKiemeltFromLanding ? 12 : 6,
                                            sm: 12,
                                            my: isKiemeltFromLanding ? 1.5 : undefined,
                                            display: "flex",
                                            justifyContent: isKiemeltFromLanding ? "start" : {
                                                xs: "start",
                                                sm: "end"
                                            },
                                            alignItems: isKiemeltFromLanding ? "center" : {
                                                xs: "center",
                                                sm: "start"
                                            },
                                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                                variant: "rectangular",
                                                sx: {
                                                    mb: 1
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemPrice, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        fontWeight: "bold",
                                                        children: [
                                                            (0,priceFormatter/* priceFormatter */.L)(item === null || item === void 0 ? void 0 : (ref4 = item.price) === null || ref4 === void 0 ? void 0 : ref4.amount, {
                                                                currency: item === null || item === void 0 ? void 0 : (ref5 = item.price) === null || ref5 === void 0 ? void 0 : ref5.currency
                                                            }),
                                                            !isKiemeltFromLanding && hasQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    " / ",
                                                                    item === null || item === void 0 ? void 0 : (ref6 = item.price) === null || ref6 === void 0 ? void 0 : ref6.quantity
                                                                ]
                                                            }) : null,
                                                            !isKiemeltFromLanding && hasFlags ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    " ",
                                                                    (0,enumTitles/* getPriceFlagString */.pe)(t, item === null || item === void 0 ? void 0 : item.price)
                                                                ]
                                                            }) : null
                                                        ]
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindItemPrice, {
                                                iskiemeltfromlanding: isKiemeltFromLanding ? 1 : 0,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    fontWeight: "bold",
                                                    children: [
                                                        (0,priceFormatter/* priceFormatter */.L)(item === null || item === void 0 ? void 0 : (ref7 = item.price) === null || ref7 === void 0 ? void 0 : ref7.amount, {
                                                            currency: item === null || item === void 0 ? void 0 : (ref8 = item.price) === null || ref8 === void 0 ? void 0 : ref8.currency
                                                        }),
                                                        !isKiemeltFromLanding && hasQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                " / ",
                                                                t(enumTitles/* priceQuantityTitle */.tz[item === null || item === void 0 ? void 0 : (ref9 = item.price) === null || ref9 === void 0 ? void 0 : ref9.quantity]).toLowerCase()
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                                        !isKiemeltFromLanding && hasFlags ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            children: [
                                                                " ",
                                                                (0,enumTitles/* getPriceFlagString */.pe)(t, item === null || item === void 0 ? void 0 : item.price)
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                                    ]
                                                })
                                            })
                                        }),
                                        type === _app.PageType.RBhuPP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 6,
                                            sm: 12,
                                            mt: "auto",
                                            display: "flex",
                                            justifyContent: "end",
                                            pr: {
                                                xs: 1,
                                                sm: 0
                                            },
                                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindSkeleton, {
                                                variant: "rectangular",
                                                width: 24,
                                                height: 24
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: item === null || item === void 0 ? void 0 : item.urlPP,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: function() {
                                                        return handleSetPosition();
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                                                        bgcolor: colors.mainColor,
                                                        bghovercolor: colors.secondaryColor,
                                                        fullWidth: false,
                                                        itembutton: 1,
                                                        variant: "contained",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                                                            fontSize: "large"
                                                        })
                                                    })
                                                })
                                            })
                                        }) : setFavButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 6,
                                            sm: isKiemeltFromLanding ? 6 : 12,
                                            mt: "auto",
                                            display: "flex",
                                            justifyContent: "end",
                                            pr: isKiemeltFromLanding ? 1 : {
                                                xs: 1,
                                                sm: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                size: "small",
                                                sx: {
                                                    p: isKiemeltFromLanding ? 0 : undefined
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteBorder/* default */.Z, {})
                                            })
                                        }) : null
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FindComponent_FindItem = (FindItem);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ChevronLeft.js
var ChevronLeft = __webpack_require__(19572);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowDown.js
var KeyboardArrowDown = __webpack_require__(75503);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowUp.js
var KeyboardArrowUp = __webpack_require__(90813);
// EXTERNAL MODULE: ./components/RBPartnerPortal/PartnerPortalLayout.tsx + 11 modules
var PartnerPortalLayout = __webpack_require__(16795);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/List/List.js + 1 modules
var List = __webpack_require__(85214);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(93481);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FilterAlt.js
var FilterAlt = __webpack_require__(68162);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/FormatLineSpacing.js
var FormatLineSpacing = __webpack_require__(33649);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(48317);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(76172);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FindFilterMobileBlock.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 


























var FindFilterMobileBlock = function(param) {
    var isMobile = param.isMobile, colors = param.colors, bazarItems = param.bazarItems, pageUrl = param.pageUrl, mmbr = param.mmbr, isSkipResult = param.isSkipResult, skipResult = param.skipResult;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref5.partnerSiteFull, templatePath = ref5.templatePath;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref6 = (0,react.useState)(false), sortOrderMobileOpen = ref6[0], setSortOrderMobileOpen = ref6[1];
    var ref7 = (0,react.useState)(bazarItems === null || bazarItems === void 0 ? void 0 : (ref = bazarItems.sortOrders) === null || ref === void 0 ? void 0 : ref.find(function(item) {
        return item.isSelected;
    })), sortOrder = ref7[0], setSortOrder = ref7[1];
    var ref8 = (0,react.useState)(false), filterDialogMobileOpen = ref8[0], setFilterDialogMobileOpen = ref8[1];
    var ref9 = (0,react.useState)(null), filterMobileSubmenuOpen = ref9[0], setFilterMobileSubmenuOpen = ref9[1];
    var ref10 = (0,react.useState)(null), filterMobileSubmenuDialogOpen = ref10[0], setFilterMobileSubmenuDialogOpen = ref10[1];
    var ref11 = (0,react.useState)(null), lastUrl = ref11[0], setLastUrl = ref11[1];
    var ref12 = (0,react.useState)(null), filterMobileSubmenuDialogTitle = ref12[0], setFilterMobileSubmenuDialogTitle = ref12[1];
    var ref13 = (0,react.useState)(null), filterMobileSubmenuDialogSubtitle = ref13[0], setFilterMobileSubmenuDialogSubtitle = ref13[1];
    var ref14;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref14 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref1 = partnerSiteFull.content) === null || ref1 === void 0 ? void 0 : ref1.templateId) !== null && ref14 !== void 0 ? ref14 : "AutoraTemplate") : templatePath;
    var type = templatePath;
    var FindFloatingButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindFloatingButton;
            });
        });
    }, [
        path
    ]);
    var FindSwipeableDrawer = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindSwipeableDrawer;
            });
        });
    }, [
        path
    ]);
    var FindMobileListItemButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindMobileListItemButton;
            });
        });
    }, [
        path
    ]);
    var FindMobileLink = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindMobileLink;
            });
        });
    }, [
        path
    ]);
    var FindFullScreenDialog = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindFullScreenDialog;
            });
        });
    }, [
        path
    ]);
    var FindFullScreenDialogContent = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindFullScreenDialogContent;
            });
        });
    }, [
        path
    ]);
    var FindFullScreenDialogActions = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindFullScreenDialogActions;
            });
        });
    }, [
        path
    ]);
    var FindMobileFilterList = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindMobileFilterList;
            });
        });
    }, [
        path
    ]);
    var FindButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindButton;
            });
        });
    }, [
        path
    ]);
    var FindFilterTitle = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindFilterTitle;
            });
        });
    }, [
        path
    ]);
    (0,react.useEffect)(function() {
        handleCloseAll();
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setSortOrderMobileOpen(false);
        }, 500);
    }, [
        bazarItems === null || bazarItems === void 0 ? void 0 : bazarItems.sortOrders
    ]);
    var toggleSortOrder = function(open) {
        return function(event) {
            if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return;
            }
            setSortOrderMobileOpen(open);
        };
    };
    var toggleFilters = function(open) {
        if (open) {
            setLastUrl(router.asPath);
        } else {
            setLastUrl(null);
        }
        skipResult(open);
        setFilterDialogMobileOpen(open);
    };
    var handleFilterMobileSubmenu = function(filters) {
        var ref;
        var newDialog = (filters === null || filters === void 0 ? void 0 : (ref = filters.items) === null || ref === void 0 ? void 0 : ref.length) > MAX_FILTER_SHOW;
        var uiMode = filters === null || filters === void 0 ? void 0 : filters.uiMode;
        if (newDialog || uiMode === swaggerClient/* ResultFilterUIMode.FindQuery */.XTk.FindQuery || uiMode === swaggerClient/* ResultFilterUIMode.LongInterval */.XTk.LongInterval || uiMode === swaggerClient/* ResultFilterUIMode.DropDown */.XTk.DropDown || uiMode === swaggerClient/* ResultFilterUIMode.SliderIntervalInteger */.XTk.SliderIntervalInteger || uiMode === swaggerClient/* ResultFilterUIMode.SliderIntevalFloat */.XTk.SliderIntevalFloat || uiMode === swaggerClient/* ResultFilterUIMode.IntervalDropDown */.XTk.IntervalDropDown) {
            setFilterMobileSubmenuOpen(null);
            setFilterMobileSubmenuDialogOpen(filters);
            setFilterMobileSubmenuDialogTitle(filters === null || filters === void 0 ? void 0 : filters.title);
            setFilterMobileSubmenuDialogSubtitle(filters === null || filters === void 0 ? void 0 : filters.subtitle);
        } else {
            setFilterMobileSubmenuOpen(function(prevOpen) {
                if (prevOpen === filters) return null;
                return filters;
            });
        }
    };
    var handleFilterMobileDialog = function(back) {
        back ? handleCloseSubDialog() : handleCloseDialog();
    };
    var handleCloseDialog = function() {
        lastUrl ? router.push(lastUrl).then(function() {
            skipResult(false);
            setFilterDialogMobileOpen(false);
            setLastUrl(null);
        }) : skipResult(false);
        setFilterDialogMobileOpen(false);
        setLastUrl(null);
    };
    var handleCloseSubDialog = function() {
        setFilterMobileSubmenuDialogOpen(null);
        setFilterMobileSubmenuDialogTitle(null);
        setFilterMobileSubmenuDialogSubtitle(null);
    };
    var handleCloseSubmenu = function() {
        setFilterMobileSubmenuOpen(null);
    };
    var handleCloseAll = function() {
        isSkipResult ? skipResult(false) : null;
        setSortOrderMobileOpen(false);
        setFilterDialogMobileOpen(false);
        setFilterMobileSubmenuOpen(null);
        setFilterMobileSubmenuDialogOpen(null);
        setFilterMobileSubmenuDialogTitle(null);
        setFilterMobileSubmenuDialogSubtitle(null);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFloatingButton, {
                variant: "extended",
                disableFocusRipple: true,
                disableTouchRipple: true,
                disableRipple: true,
                bgcolor: colors.mainColor,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    flexWrap: "nowrap",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                component: "a",
                                onClick: function() {
                                    return toggleFilters(true);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    flexWrap: "nowrap",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            mr: 0.5,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterAlt/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            children: t("web.listing.mobilSzures.szuroTitle")
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            orientation: "vertical",
                            flexItem: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            alignSelf: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                component: "a",
                                onClick: toggleSortOrder(true),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    flexWrap: "nowrap",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            mr: 0.5,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatLineSpacing/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            children: t("web.listing.mobilSzures.rendezesTitle")
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindSwipeableDrawer, {
                anchor: "bottom",
                open: sortOrderMobileOpen,
                onClose: toggleSortOrder(false),
                onOpen: toggleSortOrder(true),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFilterTitle, {
                                textAlign: "center",
                                m: 2,
                                children: t("web.listing.mobilSzures.rendezesTitle")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMobileLink, {
                                color: colors.mainColor,
                                right: 15,
                                top: type === _app.PageType.RBhuPP ? 17 : 23,
                                onClick: toggleSortOrder(false),
                                children: t("web.listing.mobilSzures.keszButtonText")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                            disablePadding: true,
                            children: bazarItems === null || bazarItems === void 0 ? void 0 : (ref2 = bazarItems.sortOrders) === null || ref2 === void 0 ? void 0 : ref2.map(function(item, i) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                            disablePadding: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: (pageUrl && pageUrl !== "/" ? pageUrl + item.url : item.url) + (type !== _app.PageType.RBhuPP && mmbr ? ((ref = item.url) === null || ref === void 0 ? void 0 : ref.includes("?")) ? "&mmbr=".concat(mmbr) : "?mmbr=".concat(mmbr) : ""),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindMobileListItemButton, {
                                                    selected: item.title == (sortOrder === null || sortOrder === void 0 ? void 0 : sortOrder.title),
                                                    selectedcolor: colors.mainColor,
                                                    onClick: function() {
                                                        return setSortOrder(item);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                                                name: "sortOrder",
                                                                checked: item.title == (sortOrder === null || sortOrder === void 0 ? void 0 : sortOrder.title),
                                                                disableFocusRipple: true,
                                                                disableRipple: true,
                                                                disableTouchRipple: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                            primary: item.title
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                    ]
                                }, i);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindFullScreenDialog, {
                open: filterDialogMobileOpen,
                fullScreen: true,
                scroll: "paper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        flexDirection: "row",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMobileLink, {
                                position: "absolute",
                                left: 15,
                                top: 19,
                                color: colors.mainColor,
                                onClick: function() {
                                    return handleFilterMobileDialog(filterMobileSubmenuDialogOpen !== null);
                                },
                                children: filterMobileSubmenuDialogOpen !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindFilterTitle, {
                                textAlign: "center",
                                m: 2,
                                display: "flex",
                                flexDirection: "column",
                                children: [
                                    t("web.listing.mobilSzures.szuroTitle"),
                                    filterMobileSubmenuDialogOpen !== null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        component: "span",
                                        fontSize: "14px",
                                        children: [
                                            filterMobileSubmenuDialogTitle,
                                            " ",
                                            filterMobileSubmenuDialogSubtitle
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: pageUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMobileLink, {
                                    position: "absolute",
                                    right: 10,
                                    top: type === _app.PageType.RBhuPP ? 17 : 22,
                                    color: colors.mainColor,
                                    children: t("web.listing.mobilSzures.visszaallitasButtonText")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFullScreenDialogContent, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                            children: filterMobileSubmenuDialogOpen !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMobileFilterList, {
                                children: FilterType(filterMobileSubmenuDialogOpen, colors, pageUrl, mmbr, isMobile, handleCloseSubDialog)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FindMobileFilterList, {
                                children: bazarItems === null || bazarItems === void 0 ? void 0 : (ref3 = bazarItems.resultFilters) === null || ref3 === void 0 ? void 0 : ref3.map(function(filters, i) {
                                    var ref;
                                    var selectedItems = filters === null || filters === void 0 ? void 0 : (ref = filters.items) === null || ref === void 0 ? void 0 : ref.filter(function(i) {
                                        return i.selected;
                                    }).map(function(i) {
                                        return (0,capitalize/* default */.Z)(i.title);
                                    }).join(", ");
                                    switch(filters.uiMode){
                                        case swaggerClient/* ResultFilterUIMode.FindQuery */.XTk.FindQuery:
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                children: [
                                                    FilterType(filters, colors, pageUrl, mmbr, isMobile),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                                ]
                                            }, i);
                                            break;
                                        case swaggerClient/* ResultFilterUIMode.CheckBox */.XTk.CheckBox:
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                                                        secondaryAction: FilterType(filters, colors, pageUrl, mmbr, isMobile),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                sx: {
                                                                    fontSize: "inherit"
                                                                },
                                                                children: filters.title
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                                ]
                                            }, i);
                                            break;
                                        case swaggerClient/* ResultFilterUIMode.UjVagyHasznalt */.XTk.UjVagyHasznalt:
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                        my: 2,
                                                        children: FilterType(filters, colors, pageUrl, mmbr, isMobile)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                                ]
                                            }, i);
                                        default:
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                                                        secondaryAction: filterMobileSubmenuOpen === filters ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                        onClick: function() {
                                                            return handleFilterMobileSubmenu(filters);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    sx: {
                                                                        fontSize: "inherit"
                                                                    },
                                                                    children: filters.title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                                                sx: {
                                                                    textAlign: "right"
                                                                },
                                                                children: selectedItems
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapse/* default */.Z, {
                                                        in: filterMobileSubmenuOpen === filters,
                                                        timeout: "auto",
                                                        unmountOnExit: true,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                                                                component: "div",
                                                                disablePadding: true,
                                                                children: FilterType(filters, colors, pageUrl, mmbr, isMobile, handleCloseSubmenu)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                                ]
                                            }, i);
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FindFullScreenDialogActions, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                            onClick: function() {
                                return handleCloseAll();
                            },
                            bgcolor: colors.mainColor,
                            bghovercolor: colors.secondaryColor,
                            variant: "contained",
                            conditionbutton: 1,
                            sx: {
                                width: "100%",
                                height: "50px"
                            },
                            children: t("web.listing.mobilSzures.keresesButtonText", {
                                adCount: bazarItems === null || bazarItems === void 0 ? void 0 : (ref4 = bazarItems.foundCount) === null || ref4 === void 0 ? void 0 : ref4.toLocaleString("hu")
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FindComponent_FindFilterMobileBlock = (FindFilterMobileBlock);

// EXTERNAL MODULE: ./utils/contexts/UIContext/UIContext.tsx + 3 modules
var UIContext = __webpack_require__(65654);
// EXTERNAL MODULE: ./design/common/LoadingComponent/LoadingComponent.tsx
var LoadingComponent = __webpack_require__(47960);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(91359);
// EXTERNAL MODULE: ./design/common/template/Typography.tsx
var template_Typography = __webpack_require__(59326);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(13379);
;// CONCATENATED MODULE: ./components/_common/FindComponent/FindHeadlinks.tsx















var FindHeadlinks = function(param) {
    var title = param.title, headlinks = param.headlinks;
    var ref;
    var ref1 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref1.partnerSiteFull, templatePath = ref1.templatePath;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(false), showAll = ref2[0], setShowAll = ref2[1];
    var ref3;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref3 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref = partnerSiteFull.content) === null || ref === void 0 ? void 0 : ref.templateId) !== null && ref3 !== void 0 ? ref3 : "AutoraTemplate") : templatePath;
    var FindHeadlinkItem = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindHeadlinkItem;
            });
        });
    }, [
        path
    ]);
    var MAX_SHOW_NUMBER = 12;
    var ref4;
    var showAllButton = (ref4 = headlinks && (headlinks === null || headlinks === void 0 ? void 0 : headlinks.length) > MAX_SHOW_NUMBER && !showAll) !== null && ref4 !== void 0 ? ref4 : false;
    var sliceNumber = showAll ? headlinks === null || headlinks === void 0 ? void 0 : headlinks.length : MAX_SHOW_NUMBER === (headlinks === null || headlinks === void 0 ? void 0 : headlinks.length) ? headlinks === null || headlinks === void 0 ? void 0 : headlinks.length : MAX_SHOW_NUMBER - 1;
    var showHeadlinks = headlinks && headlinks.length > 0;
    (0,react.useEffect)(function() {
        setShowAll(false);
    }, [
        headlinks
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        mb: 5,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            xs: 12,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        columnSpacing: 2,
                        children: [
                            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindHeadlinkItem, {
                                    istitle: 1,
                                    noheadlink: Number(!showHeadlinks),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(template_Typography.H3, {
                                        component: "h1",
                                        textTransform: "none",
                                        children: (0,capitalize/* default */.Z)(title)
                                    })
                                })
                            }) : null,
                            showHeadlinks ? headlinks === null || headlinks === void 0 ? void 0 : headlinks.slice(0, sliceNumber).map(function(item, i) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    sm: 6,
                                    lg: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: item.url,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindHeadlinkItem, {
                                            component: "a",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_Typography.H4, {
                                                    component: "div",
                                                    fontWeight: "normal",
                                                    children: (0,capitalize/* default */.Z)(item.text)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_Typography/* Small */.x4, {
                                                    children: item.count
                                                })
                                            ]
                                        })
                                    })
                                }, i);
                            }) : null,
                            showHeadlinks && showAllButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 6,
                                lg: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindHeadlinkItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        component: "span",
                                        underline: "none",
                                        onClick: function() {
                                            return setShowAll(true);
                                        },
                                        sx: {
                                            cursor: "pointer"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                            display: "flex",
                                            direction: "row",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(template_Typography.H4, {
                                                    component: "div",
                                                    fontWeight: "normal",
                                                    mr: 0.5,
                                                    children: t("web.listing.headlinks.tovabbiakTitle")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                                    sx: {
                                                        fontSize: 12
                                                    }
                                                })
                                            ]
                                        })
                                    })
                                })
                            }) : null
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var FindComponent_FindHeadlinks = (FindHeadlinks);

// EXTERNAL MODULE: ./utils/functions/categoryBannerData.ts + 1 modules
var categoryBannerData = __webpack_require__(82282);
// EXTERNAL MODULE: ./components/_common/GoogleTagManager.tsx
var GoogleTagManager = __webpack_require__(56614);
// EXTERNAL MODULE: ./components/_common/ResponsiveAdBanner/ResponsiveAdBanner.tsx
var ResponsiveAdBanner = __webpack_require__(8435);
;// CONCATENATED MODULE: ./components/_common/FindComponent/Find.tsx
/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable react-hooks/exhaustive-deps */ 


































var filterUrl = function(filters, item, url, pageUrl, mmbr) {
    var ref;
    return pageUrl && (pageUrl !== "/" ? pageUrl : "") + (item ? item.selected ? filters.resetUrl ? filters.resetUrl : item.targetUrl : item.targetUrl : url) + (mmbr ? item && !((ref = item.targetUrl) === null || ref === void 0 ? void 0 : ref.includes("?")) ? "?mmbr=".concat(mmbr) : "&mmbr=".concat(mmbr) : "");
};
var Find = function(param) {
    var data = param.data, pageUrl = param.pageUrl;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    var _query = router.query, page = _query.page, mmbr = _query.mmbr;
    var backend = (0,BackendContext/* useBackend */.nc)();
    var ui = (0,UIContext/* useUI */.l8)();
    var ref20 = (0,LayoutContext/* useLayoutData */.Qq)(), partnerSiteFull = ref20.partnerSiteFull, templatePath = ref20.templatePath, setTemplatePath = ref20.setTemplatePath;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref21 = (0,GoogleTagManager/* useGTM */.l)(), sendPageViewParams = ref21.sendPageViewParams, sendEvent = ref21.sendEvent;
    var ref22 = (0,react.useState)(null), bazarItems = ref22[0], setBazarItems = ref22[1];
    var ref23 = (0,react.useState)(null), sortOrderAnchor = ref23[0], setSortOrderAnchor = ref23[1];
    var ref24 = (0,react.useState)(theme.palette.primary.main), mainColor = ref24[0], setMainColor = ref24[1];
    var ref25 = (0,react.useState)(theme.palette.common.black), secondaryColor = ref25[0], setSecondaryColor = ref25[1];
    var sortOrderOpen = Boolean(sortOrderAnchor);
    var ref26 = (0,react.useState)(null), skipResultItems = ref26[0], setSkipResultItems = ref26[1];
    var ref27 = (0,react.useState)(false), isLoading = ref27[0], setLoading = ref27[1];
    var ref28 = (0,react.useState)(false), isNavigation = ref28[0], setNavigation = ref28[1];
    var ref29 = (0,react.useState)(null), navigationTimeout = ref29[0], setNavigationTimeout = ref29[1];
    var ref30 = (0,react.useState)(null), scrollTimeout = ref30[0], setScrollTimeout = ref30[1];
    var ref31 = (0,_sliced_to_array/* default */.Z)(hooks_useSessionStorage("listingScrollPosition", 0), 2), listingScrollPosition = ref31[0], setListingScrollPosition = ref31[1];
    var ref32 = (0,react.useState)(mmbr), mmbrId = ref32[0], setMmbrId = ref32[1];
    var type = templatePath;
    var findData = data ? data.componentData_Find : undefined;
    var findUrl = (type !== _app.PageType.RBhuPP ? "/" : router.asPath === pageUrl ? "/" : "") + router.asPath.replace(pageUrl, "");
    var clearFindUrl = findUrl.includes("?mmbr=") ? findUrl.substring(0, findUrl.indexOf("?mmbr=")) : findUrl.includes("&mmbr=") ? findUrl.substring(0, findUrl.indexOf("&mmbr=")) : findUrl;
    var isShow = type === _app.PageType.RBhuPP ? data && data.enabled ? true : false : true;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    var hasItems = (bazarItems === null || bazarItems === void 0 ? void 0 : bazarItems.items) && bazarItems.items.length > 0;
    var hasKiemeltItems = (bazarItems === null || bazarItems === void 0 ? void 0 : bazarItems.itemsKiemelt) && bazarItems.itemsKiemelt.length > 0;
    var hasPrevUrl = Boolean(bazarItems === null || bazarItems === void 0 ? void 0 : (ref = bazarItems.paging) === null || ref === void 0 ? void 0 : ref.prevPageUrl);
    var hasNextUrl = Boolean(bazarItems === null || bazarItems === void 0 ? void 0 : (ref1 = bazarItems.paging) === null || ref1 === void 0 ? void 0 : ref1.nextPageUrl);
    var prevUrl = (bazarItems === null || bazarItems === void 0 ? void 0 : (ref2 = bazarItems.paging) === null || ref2 === void 0 ? void 0 : ref2.prevPageUrl) ? (type === _app.PageType.RBhuPP ? pageUrl : "") + (bazarItems === null || bazarItems === void 0 ? void 0 : (ref3 = bazarItems.paging) === null || ref3 === void 0 ? void 0 : ref3.prevPageUrl) + (mmbrId ? (bazarItems === null || bazarItems === void 0 ? void 0 : (ref4 = bazarItems.paging) === null || ref4 === void 0 ? void 0 : ref4.prevPageUrl.includes("?")) ? "&mmbr=".concat(mmbrId) : "?mmbr=".concat(mmbrId) : "") : "#";
    var nextUrl = (bazarItems === null || bazarItems === void 0 ? void 0 : (ref5 = bazarItems.paging) === null || ref5 === void 0 ? void 0 : ref5.nextPageUrl) ? (type === _app.PageType.RBhuPP ? pageUrl : "") + (bazarItems === null || bazarItems === void 0 ? void 0 : (ref6 = bazarItems.paging) === null || ref6 === void 0 ? void 0 : ref6.nextPageUrl) + (mmbrId ? (bazarItems === null || bazarItems === void 0 ? void 0 : (ref7 = bazarItems.paging) === null || ref7 === void 0 ? void 0 : ref7.nextPageUrl.includes("?")) ? "&mmbr=".concat(mmbrId) : "?mmbr=".concat(mmbrId) : "") : "#";
    var ref33;
    var path = templatePath === _app.PageType.RBhuPP ? "".concat(templatePath, "/templates/").concat((ref33 = partnerSiteFull === null || partnerSiteFull === void 0 ? void 0 : (ref8 = partnerSiteFull.content) === null || ref8 === void 0 ? void 0 : ref8.templateId) !== null && ref33 !== void 0 ? ref33 : "AutoraTemplate") : templatePath;
    var setColors = function() {
        setMainColor(function(prevMainColor) {
            var ref;
            return (ref = (0,PartnerPortalLayout/* colorSetter */.F1)(partnerSiteFull, "mainColor")) !== null && ref !== void 0 ? ref : prevMainColor;
        });
        setSecondaryColor(function(prevSecondaryColor) {
            var ref;
            return (ref = (0,PartnerPortalLayout/* colorSetter */.F1)(partnerSiteFull, "secondaryColor")) !== null && ref !== void 0 ? ref : prevSecondaryColor;
        });
    };
    var handleTemplatePath = function() {
        switch(type){
            case _app.PageType.RBhu:
                setTemplatePath(_app.PageType.RBhu);
                break;
            case _app.PageType.RBhuPP:
                setTemplatePath(_app.PageType.RBhuPP);
                break;
            case _app.PageType.SZP:
                setTemplatePath(_app.PageType.SZP);
                break;
            case _app.PageType.SZPPL:
                setTemplatePath(_app.PageType.SZPPL);
                break;
            default:
                setTemplatePath(_app.PageType.RBhu);
                break;
        }
    };
    var getFindList = function() {
        var ref, ref1, ref2, ref3, ref4;
        setLoading(true);
        backend.api.adFindList({
            findUrl: clearFindUrl,
            defaultFilters: {
                memberFilter: type === _app.PageType.RBhuPP && findData ? (ref = findData.defaultFilters) === null || ref === void 0 ? void 0 : ref.memberFilter : mmbrId ? mmbrId : undefined,
                subsiteFilter: type === _app.PageType.RBhuPP && findData ? (ref1 = findData.defaultFilters) === null || ref1 === void 0 ? void 0 : ref1.subsiteFilter : undefined,
                groupSubjectFilter: type === _app.PageType.RBhuPP && findData ? (ref2 = findData.defaultFilters) === null || ref2 === void 0 ? void 0 : ref2.groupSubjectFilter : undefined,
                carMakeFilter: type === _app.PageType.RBhuPP && findData ? (ref3 = findData.defaultFilters) === null || ref3 === void 0 ? void 0 : ref3.carMakeFilter : undefined,
                gumiFelniKindFilter: type === _app.PageType.RBhuPP && findData ? (ref4 = findData.defaultFilters) === null || ref4 === void 0 ? void 0 : ref4.gumiFelniKindFilter : undefined
            },
            skipResultItems: skipResultItems
        }).then(function(res) {
            if (res.redirectTo) {
                router.push(res.redirectTo);
                return null;
            }
            setBazarItems(res.result);
            setLoading(false);
            if (isNavigation) {
                if (navigationTimeout) clearTimeout(navigationTimeout);
                setNavigationTimeout(setTimeout(function() {
                    return window.scrollTo(0, 0);
                }, 100));
                setNavigation(false);
            }
            if (listingScrollPosition && listingScrollPosition !== 0) {
                if (scrollTimeout) clearTimeout(scrollTimeout);
                setScrollTimeout(setTimeout(function() {
                    return window.scrollTo(0, listingScrollPosition);
                }, 100));
                setListingScrollPosition(null);
            }
            if (res.gaPageViewModel) {
                sendPageViewParams(res.gaPageViewModel);
            }
            if (res.gaEvents) {
                res.gaEvents.forEach(function(event) {
                    sendEvent(event);
                });
            }
        }).catch(function(err) {
            ui.errorDisplay(err);
            setLoading(false);
            setNavigation(false);
        });
    };
    (0,react.useEffect)(function() {
        if (type === _app.PageType.RBhuPP && (pageUrl === null || pageUrl === void 0 ? void 0 : pageUrl.replace("/", "")) !== (page === null || page === void 0 ? void 0 : page[0])) return;
        if (type === _app.PageType.RBhuPP) getFindList();
        if (type !== _app.PageType.RBhuPP && ![
            "/SZP",
            "/RBhu"
        ].some(function(word) {
            return clearFindUrl.startsWith(word);
        })) getFindList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clearFindUrl
    ]);
    (0,react.useEffect)(function() {
        if (skipResultItems === null) return;
        if (skipResultItems === false) {
            getFindList();
            setSkipResultItems(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        skipResultItems
    ]);
    (0,react.useEffect)(function() {
        handleTemplatePath();
        if (type !== _app.PageType.RBhuPP || partnerSiteFull === undefined) return;
        setColors();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        type,
        bazarItems,
        partnerSiteFull,
        templatePath
    ]);
    (0,react.useEffect)(function() {
        if (router.isReady && !mmbr) {
            var query = new URLSearchParams(window.location.search);
            if (query.has("mmbr")) setMmbrId(query.get("mmbr"));
        }
    });
    var handleSortOrderOpen = function(e) {
        return setSortOrderAnchor(e.currentTarget);
    };
    var handleSortOrderClose = function() {
        return setSortOrderAnchor(undefined);
    };
    var FindContainer = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindContainer;
            });
        });
    }, [
        path
    ]);
    var FindHeaderGridContainer = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindHeaderGridContainer;
            });
        });
    }, [
        path
    ]);
    var FindHeaderTitle = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindHeaderTitle;
            });
        });
    }, [
        path
    ]);
    var FindButton = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindButton;
            });
        });
    }, [
        path
    ]);
    var FindDropdownMenu = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindDropdownMenu;
            });
        });
    }, [
        path
    ]);
    var FindDropdownMenuItem = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindDropdownMenuItem;
            });
        });
    }, [
        path
    ]);
    var FindTitle = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindTitle;
            });
        });
    }, [
        path
    ]);
    var FindBreadcrumbs = (0,react.useMemo)(function() {
        return dynamic_default()(function() {
            return __webpack_require__(8573)("./".concat(path, "/_findDesign/Design")).then(function(style) {
                return style.FindBreadcrumbs;
            });
        });
    }, [
        path
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2;
        if (bazarItems === null || bazarItems === void 0 ? void 0 : (ref = bazarItems.pageModel) === null || ref === void 0 ? void 0 : ref.htmlTitle) ui.seoTextsSetter(UIContext/* SeoTextKind.HtmlTitle */.gy.HtmlTitle, bazarItems.pageModel.htmlTitle);
        if (bazarItems === null || bazarItems === void 0 ? void 0 : (ref1 = bazarItems.pageModel) === null || ref1 === void 0 ? void 0 : ref1.htmlDesc) ui.seoTextsSetter(UIContext/* SeoTextKind.HtmlDescription */.gy.HtmlDescription, bazarItems.pageModel.htmlDesc);
        if (bazarItems === null || bazarItems === void 0 ? void 0 : (ref2 = bazarItems.pageModel) === null || ref2 === void 0 ? void 0 : ref2.canonicalUrl) ui.seoTextsSetter(UIContext/* SeoTextKind.CanonicalUrl */.gy.CanonicalUrl, bazarItems.pageModel.canonicalUrl);
    }, [
        bazarItems === null || bazarItems === void 0 ? void 0 : bazarItems.pageModel
    ]);
    var _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !bazarItems ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
            sx: {
                minHeight: "100vh"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindContainer, {
                maxWidth: false,
                sx: {
                    mt: 4
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingComponent/* default */.Z, {
                    customColor: mainColor,
                    noElevation: type === _app.PageType.RBhuPP,
                    transparent: type === _app.PageType.RBhuPP
                })
            })
        }) : isShow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            sx: {
                minHeight: "100vh"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindContainer, {
                    maxWidth: false,
                    children: [
                        type !== _app.PageType.RBhuPP ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FindBreadcrumbs, {
                                    children: isLoading ? (0,_to_consumable_array/* default */.Z)(Array(router.asPath.split("/").length - 1)).map(function(_, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                width: 100,
                                                height: 20,
                                                variant: "rounded"
                                            })
                                        }, i);
                                    }) : bazarItems === null || bazarItems === void 0 ? void 0 : (ref9 = bazarItems.breadcrumb) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.items) === null || ref10 === void 0 ? void 0 : ref10.map(function(breadcrumb, i) {
                                        return breadcrumb.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: breadcrumb.url,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                underline: "hover",
                                                variant: "body2",
                                                children: breadcrumb.title
                                            })
                                        }, i) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            children: breadcrumb.title
                                        }, i);
                                    })
                                }),
                                type === _app.PageType.SZP && bazarItems.categoryBanners ? bazarItems.categoryBanners.map(function(banner, i) {
                                    if (!(0,categoryBannerData/* getCategoryBannerData */._)(banner)) return null;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        container: true,
                                        mb: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            display: "flex",
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveAdBanner/* default */.Z, {
                                                adUnit: (0,categoryBannerData/* getCategoryBannerData */._)(banner).adUnit,
                                                name: (0,categoryBannerData/* getCategoryBannerData */._)(banner).name,
                                                size: [
                                                    [
                                                        1280,
                                                        108
                                                    ],
                                                    [
                                                        600,
                                                        188
                                                    ],
                                                    [
                                                        1,
                                                        1
                                                    ]
                                                ]
                                            })
                                        })
                                    }, i);
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindHeadlinks, {
                                    title: (ref11 = bazarItems.pageModel) === null || ref11 === void 0 ? void 0 : ref11.pageTitle,
                                    headlinks: bazarItems.headlinks
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            children: [
                                !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 3,
                                    pl: 2,
                                    pr: type !== _app.PageType.RBhuPP ? 2 : 0,
                                    pt: type !== _app.PageType.RBhuPP ? 2 : 0,
                                    height: "100%",
                                    bgcolor: type !== _app.PageType.RBhuPP ? theme.palette.mode === "dark" ? theme.palette.grey[900] : theme.palette.common.white : undefined,
                                    borderRadius: type === _app.PageType.SZP || type === _app.PageType.SZPPL ? "8px" : undefined,
                                    boxShadow: type === _app.PageType.SZP || type === _app.PageType.SZPPL ? "0px 1px 3px rgba(3, 0, 71, 0.09)" : undefined,
                                    children: bazarItems === null || bazarItems === void 0 ? void 0 : (ref12 = bazarItems.resultFilters) === null || ref12 === void 0 ? void 0 : ref12.map(function(filters, i) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindFilterBlock, {
                                            filters: filters,
                                            pageUrl: pageUrl,
                                            colors: {
                                                mainColor: mainColor,
                                                secondaryColor: secondaryColor
                                            }
                                        }, (_title = filters.title) !== null && _title !== void 0 ? _title : i);
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    md: 9,
                                    pl: isMobile ? 0 : 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FindHeaderGridContainer, {
                                            container: true,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            px: {
                                                xs: 1,
                                                sm: 0
                                            },
                                            mb: 1,
                                            pb: 1,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                        flexDirection: "row",
                                                        children: [
                                                            type !== _app.PageType.RBhuPP && mmbrId ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                variant: "h6",
                                                                fontWeight: "bold",
                                                                lineHeight: 1,
                                                                mr: 1,
                                                                children: [
                                                                    "[",
                                                                    t("web.listing.hirdetoText"),
                                                                    " #",
                                                                    mmbrId,
                                                                    "]"
                                                                ]
                                                            }) : "",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FindHeaderTitle, {
                                                                children: type !== _app.PageType.RBhuPP && mmbrId ? t("web.listing.hirdetesText", {
                                                                    adCount: bazarItems === null || bazarItems === void 0 ? void 0 : (ref13 = bazarItems.foundCount) === null || ref13 === void 0 ? void 0 : ref13.toLocaleString("hu-HU")
                                                                }) : t("web.listing.talalatText", {
                                                                    adCount: bazarItems === null || bazarItems === void 0 ? void 0 : (ref14 = bazarItems.foundCount) === null || ref14 === void 0 ? void 0 : ref14.toLocaleString("hu-HU")
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                    item: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                                                            id: "dropdown-button",
                                                            "aria-controls": sortOrderOpen ? "dropdown-menu" : undefined,
                                                            "aria-haspopup": "true",
                                                            "aria-expanded": sortOrderOpen ? "true" : undefined,
                                                            bgcolor: mainColor,
                                                            bghovercolor: secondaryColor,
                                                            dropdown: 1,
                                                            onClick: handleSortOrderOpen,
                                                            variant: "contained",
                                                            endIcon: type !== _app.PageType.RBhuPP ? sortOrderOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowUp/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown/* default */.Z, {}) : undefined,
                                                            children: bazarItems === null || bazarItems === void 0 ? void 0 : (ref15 = bazarItems.sortOrders) === null || ref15 === void 0 ? void 0 : ref15.map(function(item) {
                                                                return item.isSelected ? item.title : null;
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FindDropdownMenu, {
                                                            id: "dropdown-menu",
                                                            anchorEl: sortOrderAnchor,
                                                            open: sortOrderOpen,
                                                            onClose: handleSortOrderClose,
                                                            MenuListProps: {
                                                                "aria-labelledby": "dropdown-button"
                                                            },
                                                            anchorOrigin: {
                                                                vertical: "bottom",
                                                                horizontal: "right"
                                                            },
                                                            transformOrigin: {
                                                                vertical: "top",
                                                                horizontal: "right"
                                                            },
                                                            children: bazarItems === null || bazarItems === void 0 ? void 0 : (ref16 = bazarItems.sortOrders) === null || ref16 === void 0 ? void 0 : ref16.map(function(item, i) {
                                                                var ref;
                                                                var url = (pageUrl && pageUrl !== "/" ? pageUrl + item.url : item.url) + (type !== _app.PageType.RBhuPP && mmbrId ? ((ref = item.url) === null || ref === void 0 ? void 0 : ref.includes("?")) ? "&mmbr=".concat(mmbrId) : "?mmbr=".concat(mmbrId) : "");
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: url,
                                                                    scroll: false,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindDropdownMenuItem, {
                                                                        selected: item.isSelected,
                                                                        bgcolor: mainColor,
                                                                        onClick: handleSortOrderClose,
                                                                        children: item.title
                                                                    })
                                                                }, i);
                                                            })
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            container: true,
                                            mb: 2,
                                            px: {
                                                xs: 1,
                                                sm: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: bazarItems === null || bazarItems === void 0 ? void 0 : (ref17 = bazarItems.resultFilters) === null || ref17 === void 0 ? void 0 : ref17.map(function(filters, i) {
                                                    return (filters === null || filters === void 0 ? void 0 : filters.resetBadgeText) && (filters === null || filters === void 0 ? void 0 : filters.resetBadgeText) !== "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindFilterBadge, {
                                                        title: filters.resetBadgeText,
                                                        resetUrl: filters.resetUrl,
                                                        pageUrl: page && page[0],
                                                        colors: {
                                                            mainColor: mainColor,
                                                            secondaryColor: secondaryColor
                                                        }
                                                    }, i) : null;
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            container: true,
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 12,
                                                children: [
                                                    hasKiemeltItems && type !== _app.PageType.RBhuPP ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: bazarItems === null || bazarItems === void 0 ? void 0 : (ref18 = bazarItems.itemsKiemelt) === null || ref18 === void 0 ? void 0 : ref18.map(function(item, i) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindItem, {
                                                                item: item,
                                                                colors: {
                                                                    mainColor: mainColor,
                                                                    secondaryColor: secondaryColor
                                                                },
                                                                isLoading: isLoading,
                                                                isKiemelt: true,
                                                                setFavButton: false,
                                                                preload: i < 2
                                                            }, i);
                                                        })
                                                    }) : null,
                                                    hasItems ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            bazarItems === null || bazarItems === void 0 ? void 0 : (ref19 = bazarItems.items) === null || ref19 === void 0 ? void 0 : ref19.map(function(item, i) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindItem, {
                                                                    item: item,
                                                                    colors: {
                                                                        mainColor: mainColor,
                                                                        secondaryColor: secondaryColor
                                                                    },
                                                                    isLoading: isLoading,
                                                                    setFavButton: false,
                                                                    preload: i < 2
                                                                }, i);
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                                                flexDirection: "row",
                                                                justifyContent: "end",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: prevUrl,
                                                                        passHref: true,
                                                                        scroll: false,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            className: !hasPrevUrl ? "disabled" : "",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                                                                                disabled: !hasPrevUrl,
                                                                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {}),
                                                                                filterbutton: 1,
                                                                                navigation: 1,
                                                                                variant: "outlined",
                                                                                bgcolor: mainColor,
                                                                                bghovercolor: secondaryColor,
                                                                                onClick: function() {
                                                                                    return setNavigation(true);
                                                                                },
                                                                                children: t("web.listing.elozoButtonText")
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: nextUrl,
                                                                        passHref: true,
                                                                        scroll: false,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            className: !hasNextUrl ? "disabled" : "",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindButton, {
                                                                                disabled: !hasNextUrl,
                                                                                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {}),
                                                                                filterbutton: 1,
                                                                                navigation: 1,
                                                                                variant: "outlined",
                                                                                bgcolor: mainColor,
                                                                                bghovercolor: secondaryColor,
                                                                                onClick: function() {
                                                                                    return setNavigation(true);
                                                                                },
                                                                                children: t("web.listing.kovetkezoButtonText")
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                        alignItems: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                                            sx: {
                                                                color: mainColor
                                                            }
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                                                        textAlign: "center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FindTitle, {
                                                            children: t("web.listing.nincsTalalatText")
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FindComponent_FindFilterMobileBlock, {
                    isMobile: isMobile,
                    bazarItems: bazarItems,
                    pageUrl: pageUrl,
                    mmbr: mmbrId !== null && mmbrId !== void 0 ? mmbrId : undefined,
                    colors: {
                        mainColor: mainColor,
                        secondaryColor: secondaryColor
                    },
                    isSkipResult: skipResultItems,
                    skipResult: setSkipResultItems
                }) : null
            ]
        }) : null
    });
};
/* harmony default export */ var FindComponent_Find = (Find);


/***/ }),

/***/ 8435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30120);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_ad_manager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75156);
/* eslint-disable react-hooks/exhaustive-deps */ 




var ResponsiveAdBanner = function(props) {
    var bannerScalerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("(max-width: 600px)");
    var resizeBanner = function() {
        if (bannerScalerRef.current && containerRef.current) {
            var containerWidth = containerRef.current.offsetWidth;
            var maxBannerWidth = isMobile ? 600 : 1280;
            var scale = Math.min(containerWidth / maxBannerWidth, 1);
            bannerScalerRef.current.style.transform = "scale(".concat(scale, ")");
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        window.addEventListener("resize", resizeBanner);
        window.addEventListener("load", resizeBanner);
        if (bannerScalerRef.current && containerRef.current) {
            setTimeout(function() {
                resizeBanner();
            }, 100);
        }
        return function() {
            window.removeEventListener("resize", resizeBanner);
            window.removeEventListener("load", resizeBanner);
        };
    }, [
        bannerScalerRef,
        containerRef,
        isMobile,
        router.isReady
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        ref: containerRef,
        sx: {
            maxWidth: "100%",
            overflowX: "hidden",
            display: "block",
            margin: "0 auto"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            ref: bannerScalerRef,
            sx: {
                width: "fit-content",
                transformOrigin: "top left",
                margin: "0 auto"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_ad_manager__WEBPACK_IMPORTED_MODULE_3__.Ad, {
                adUnit: props.adUnit,
                name: props.name,
                size: props.size
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveAdBanner);


/***/ }),

/***/ 47960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49837);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91359);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9144);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70754);


var LoadingComponent = function(param) {
    var _color = param.color, color = _color === void 0 ? "primary" : _color, _customColor = param.customColor, customColor = _customColor === void 0 ? null : _customColor, _size = param.size, size = _size === void 0 ? 40 : _size, _noElevation = param.noElevation, noElevation = _noElevation === void 0 ? false : _noElevation, _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        elevation: noElevation ? 0 : undefined,
        style: transparent ? {
            backgroundColor: "transparent"
        } : {},
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            sx: {
                p: 2
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                direction: "row",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    sx: {
                        color: customColor !== null && customColor !== void 0 ? customColor : undefined
                    },
                    color: customColor ? undefined : color,
                    size: size
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingComponent);


/***/ }),

/***/ 82282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ getCategoryBannerData; }
});

// EXTERNAL MODULE: ./client/swaggerClient.ts + 11 modules
var swaggerClient = __webpack_require__(84160);
;// CONCATENATED MODULE: ./components/_common/LandingPageComponent/LandingPage.types.ts
var KiemeltekNavButtonType;
(function(KiemeltekNavButtonType) {
    KiemeltekNavButtonType[KiemeltekNavButtonType["Next"] = 0] = "Next";
    KiemeltekNavButtonType[KiemeltekNavButtonType["Prev"] = 1] = "Prev";
    KiemeltekNavButtonType[KiemeltekNavButtonType["First"] = 2] = "First";
})(KiemeltekNavButtonType || (KiemeltekNavButtonType = {}));
var LandingPageBanner;
(function(LandingPageBanner) {
    LandingPageBanner["CategoryAlatt"] = "CategoryAlatt";
})(LandingPageBanner || (LandingPageBanner = {}));

;// CONCATENATED MODULE: ./utils/functions/categoryBannerData.ts


var getCategoryBannerData = function(name) {
    switch(name){
        case swaggerClient/* CategoryBannerCustomer.Sisilla */.FYm.Sisilla:
            return {
                adUnit: "/61270011/SZP_Gepek_kategoria",
                name: "div-SZP_Gepek_kategoria"
            };
        case swaggerClient/* CategoryBannerCustomer.Femgepszer */.FYm.Femgepszer:
            return {
                adUnit: "/61270011/SZP_szerszamgep_femipar_kategoria",
                name: "div-SZP_szerszamgep_femipar_kategoria"
            };
        case LandingPageBanner.CategoryAlatt:
            return {
                adUnit: "/61270011/szp_landing_categoryalatt",
                name: "div-szp_landing_categoryalatt"
            };
        default:
            return null;
    }
};


/***/ }),

/***/ 28461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C5": function() { return /* binding */ pfSzalagKiemelesVariantTitle; },
/* harmony export */   "U8": function() { return /* binding */ buyOrSellKindText; },
/* harmony export */   "aW": function() { return /* binding */ purchasePeriodTitle; },
/* harmony export */   "jD": function() { return /* binding */ nodeEnvText; },
/* harmony export */   "kq": function() { return /* binding */ purchasePaymodeTitle; },
/* harmony export */   "pe": function() { return /* binding */ getPriceFlagString; },
/* harmony export */   "tz": function() { return /* binding */ priceQuantityTitle; },
/* harmony export */   "ub": function() { return /* binding */ ujVagyHasznaltKindText; }
/* harmony export */ });
/* unused harmony exports priceFlagTitle, adPostModelNextButtonTitle, planOrderKindTitle, adManagerFilterTabTitle, adManagerSortOrderTitle, planFeatureKindTitle, planFeatureOldKindTitle */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84160);


var _obj;
// Általános, több helyen használt title-k
var purchasePaymodeTitle = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePaymode.NincsMegadva */ .pcn.NincsMegadva, "common.purchasePaymode.nincsMegadva"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePaymode.Transfer */ .pcn.Transfer, "common.purchasePaymode.transfer"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePaymode.SMS */ .pcn.SMS, "common.purchasePaymode.sms"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePaymode.Card */ .pcn.Card, "common.purchasePaymode.card"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePaymode.Paypal */ .pcn.Paypal, "common.purchasePaymode.paypal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePaymode.Csekk */ .pcn.Csekk, "common.purchasePaymode.csekk"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePaymode.Other */ .pcn.Other, "common.purchasePaymode.other"), _obj);
var _obj1;
var purchasePeriodTitle = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePeriod.NincsMegadva */ .uQ.NincsMegadva, "common.purchasePeriod.nincsMegadva"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePeriod.Monthly */ .uQ.Monthly, "common.purchasePeriod.monthly"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PurchasePeriod.Yearly */ .uQ.Yearly, "common.purchasePeriod.yearly"), _obj1);
var _obj2;
var priceQuantityTitle = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceQuantity.Alkalom */ .Q2N.Alkalom, "common.priceQuantity.alkalom"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceQuantity.Darab */ .Q2N.Darab, "common.priceQuantity.darab"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceQuantity.Ev */ .Q2N.Ev, "common.priceQuantity.ev"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceQuantity.Garnitura */ .Q2N.Garnitura, "common.priceQuantity.garnitura"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceQuantity.Ho */ .Q2N.Ho, "common.priceQuantity.ho"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceQuantity.Nap */ .Q2N.Nap, "common.priceQuantity.nap"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceQuantity.Oldal */ .Q2N.Oldal, "common.priceQuantity.oldal"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj2, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceQuantity.Par */ .Q2N.Par, "common.priceQuantity.par"), _obj2);
var _obj3;
var priceFlagTitle = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.FixAr */ .jVv.FixAr, "common.priceFlag.fixAr"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.Iranyar */ .jVv.Iranyar, "common.priceFlag.iranyar"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj3, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.PluszAfa */ .jVv.PluszAfa, "common.priceFlag.pluszAfa"), _obj3);
var _obj4;
var ujVagyHasznaltKindText = (_obj4 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .UjVagyHasznaltKind.Uj */ .FTc.Uj, "common.ujVagyHasznaltKind.uj"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .UjVagyHasznaltKind.Hasznalt */ .FTc.Hasznalt, "common.ujVagyHasznaltKind.hasznalt"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj4, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .UjVagyHasznaltKind.Felujitott */ .FTc.Felujitott, "common.ujVagyHasznaltKind.felujitott"), _obj4);
var _obj5;
var buyOrSellKindText = (_obj5 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrSellKind.BerbeAd */ .MGz.BerbeAd, "common.buyOrSellKind.berdbeAd"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrSellKind.Berelne */ .MGz.Berelne, "common.buyOrSellKind.berelne"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrSellKind.Elado */ .MGz.Elado, "common.buyOrSellKind.elado"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj5, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .BuyOrSellKind.Keres */ .MGz.Keres, "common.buyOrSellKind.keres"), _obj5);
var _obj6;
var pfSzalagKiemelesVariantTitle = (_obj6 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PFSzalagKiemelesVariant.AkciosAr */ .pxT.AkciosAr, "common.pfSzalagKiemelesVariant.akciosAr"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PFSzalagKiemelesVariant.Alkukepes */ .pxT.Alkukepes, "common.pfSzalagKiemelesVariant.alkukepes"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PFSzalagKiemelesVariant.IngyenesSzallitas */ .pxT.IngyenesSzallitas, "common.pfSzalagKiemelesVariant.ingyenesSzallitas"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj6, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PFSzalagKiemelesVariant.UtolsoDarab */ .pxT.UtolsoDarab, "common.pfSzalagKiemelesVariant.utolsoDarab"), _obj6);
var _obj7;
// Konkrét komponensekben használt title-k
var adPostModelNextButtonTitle = (_obj7 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj7, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdPostModelNextButtonKind.NextButton */ .N6x.NextButton, "web.adPost.adPostModelNextButtonKind.nextButton"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj7, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdPostModelNextButtonKind.FinishButton */ .N6x.FinishButton, "web.adPost.adPostModelNextButtonKind.finishButton"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj7, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdPostModelNextButtonKind.FinishOrHighlightButton */ .N6x.FinishOrHighlightButton, "web.adPost.adPostModelNextButtonKind.finishOrHighlightButton"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj7, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdPostModelNextButtonKind.EditingSave */ .N6x.EditingSave, "web.adPost.adPostModelNextButtonKind.editSave"), _obj7);
var _obj8;
var planOrderKindTitle = (_obj8 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj8, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanOrderKind.NewOrder */ .zP.NewOrder, "web.plan.planOrderKind.newOrder"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj8, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanOrderKind.Upgrade */ .zP.Upgrade, "web.plan.planOrderKind.upgrade"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj8, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanOrderKind.Downgrade */ .zP.Downgrade, "web.plan.planOrderKind.downgrade"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj8, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanOrderKind.Cancel */ .zP.Cancel, "web.plan.planOrderKind.cancel"), _obj8);
var _obj9;
var adManagerFilterTabTitle = (_obj9 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj9, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerFilterTab.NotDeleted */ .s2q.NotDeleted, "web.dashboard.adManager.adNotDeleteTab"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj9, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerFilterTab.UserDeleted */ .s2q.UserDeleted, "web.dashboard.adManager.adUserDeletedTab"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj9, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerFilterTab.Expired */ .s2q.Expired, "web.dashboard.adManager.adExpiredTab"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj9, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerFilterTab.Massimported */ .s2q.Massimported, "web.dashboard.adManager.adMassimportedTab"), _obj9);
var _obj10;
var adManagerSortOrderTitle = (_obj10 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerSortOrder.DisplayedAt */ .$pb.DisplayedAt, "web.dashboard.adManager.adRendezes.displayedAt"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerSortOrder.DeletedAt */ .$pb.DeletedAt, "web.dashboard.adManager.adRendezes.deletedAt"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerSortOrder.ExpireAsc */ .$pb.ExpireAsc, "web.dashboard.adManager.adRendezes.expireAsc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerSortOrder.ExpireDesc */ .$pb.ExpireDesc, "web.dashboard.adManager.adRendezes.expireDesc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerSortOrder.PriceAsc */ .$pb.PriceAsc, "web.dashboard.adManager.adRendezes.priceAsc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerSortOrder.PriceDesc */ .$pb.PriceDesc, "web.dashboard.adManager.adRendezes.priceDesc"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj10, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .AdManagerSortOrder.VisitCountDesc */ .$pb.VisitCountDesc, "web.dashboard.adManager.adRendezes.visitCountDesc"), _obj10);
var _obj11;
var planFeatureKindTitle = (_obj11 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanFeatureKind.PFAktivHirdetesLimit */ .WqZ.PFAktivHirdetesLimit, "web.adKiemeles.planFutureKind.pfAktivHirdetesLimit"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanFeatureKind.PFAutoElorehozas */ .WqZ.PFAutoElorehozas, "web.adKiemeles.planFutureKind.pfAutoElorehozas"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanFeatureKind.PFKezdooldalKiemeles */ .WqZ.PFKezdooldalKiemeles, "web.adKiemeles.planFutureKind.pfKezdooldalKiemeles"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanFeatureKind.PFListaFolottiKiemeles */ .WqZ.PFListaFolottiKiemeles, "web.adKiemeles.planFutureKind.pfListaFolottiKiemeles"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanFeatureKind.PFMassimport */ .WqZ.PFMassimport, "web.adKiemeles.planFutureKind.pfMassimport"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanFeatureKind.PFSzalagKiemeles */ .WqZ.PFSzalagKiemeles, "web.adKiemeles.planFutureKind.pfSzalagKiemeles"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj11, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanFeatureKind.AdPostLimit */ .WqZ.AdPostLimit, "web.adKiemeles.planFutureKind.pfAdPostLimit"), _obj11);
var planFeatureOldKindTitle = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PlanFeatureKind.AdPostLimit */ .WqZ.AdPostLimit, "web.adKiemeles.planFutureKind.pfAdPostLimit");
var nodeEnvText = {
    "production": "PROD",
    "development": "DEV"
};
var getPriceFlagString = function(t, price) {
    var ref, ref1, ref2;
    var priceFlagString = "";
    if (price === null || price === void 0 ? void 0 : (ref = price.flags) === null || ref === void 0 ? void 0 : ref.includes(_client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.Iranyar */ .jVv.Iranyar)) priceFlagString += "(".concat(t(priceFlagTitle[_client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.Iranyar */ .jVv.Iranyar]), ") ");
    if (price === null || price === void 0 ? void 0 : (ref1 = price.flags) === null || ref1 === void 0 ? void 0 : ref1.includes(_client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.FixAr */ .jVv.FixAr)) priceFlagString += "(".concat(t(priceFlagTitle[_client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.FixAr */ .jVv.FixAr]), ") ");
    if (price === null || price === void 0 ? void 0 : (ref2 = price.flags) === null || ref2 === void 0 ? void 0 : ref2.includes(_client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.PluszAfa */ .jVv.PluszAfa)) priceFlagString += "(".concat(t(priceFlagTitle[_client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PriceFlag.PluszAfa */ .jVv.PluszAfa]), ")");
    return priceFlagString;
};


/***/ }),

/***/ 33975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ imageURL; }
/* harmony export */ });
var imageURL = function(path, url) {
    return url ? (url === null || url === void 0 ? void 0 : url.startsWith("http://")) || (url === null || url === void 0 ? void 0 : url.startsWith("https://")) ? url : "".concat(path).concat(url) : null;
};


/***/ }),

/***/ 60121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ priceFormatter; }
/* harmony export */ });
var priceFormatter = function(price) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (price === undefined) return "Nincs \xe1r";
    var currencyDetails = {
        EUR: {
            symbol: "€",
            position: "after"
        },
        USD: {
            symbol: "$",
            position: "before"
        },
        JPY: {
            symbol: "\xa5",
            position: "before"
        },
        BGN: {
            symbol: "лв",
            position: "after"
        },
        CZK: {
            symbol: "Kč",
            position: "after"
        },
        DKK: {
            symbol: "kr",
            position: "after"
        },
        GBP: {
            symbol: "\xa3",
            position: "before"
        },
        HUF: {
            symbol: "Ft",
            position: "after"
        },
        PLN: {
            symbol: "zł",
            position: "after"
        },
        RON: {
            symbol: "lei",
            position: "after"
        },
        SEK: {
            symbol: "kr",
            position: "after"
        },
        CHF: {
            symbol: "CHF",
            position: "after"
        },
        NOK: {
            symbol: "kr",
            position: "after"
        },
        HRK: {
            symbol: "kn",
            position: "after"
        },
        RUB: {
            symbol: "₽",
            position: "after"
        },
        TRY: {
            symbol: "₺",
            position: "before"
        },
        AUD: {
            symbol: "A$",
            position: "before"
        },
        BRL: {
            symbol: "R$",
            position: "before"
        },
        CAD: {
            symbol: "C$",
            position: "before"
        },
        CNY: {
            symbol: "\xa5",
            position: "before"
        },
        HKD: {
            symbol: "HK$",
            position: "before"
        },
        IDR: {
            symbol: "Rp",
            position: "before"
        },
        ILS: {
            symbol: "₪",
            position: "before"
        },
        INR: {
            symbol: "₹",
            position: "before"
        },
        KRW: {
            symbol: "₩",
            position: "before"
        },
        MXN: {
            symbol: "$",
            position: "before"
        },
        MYR: {
            symbol: "RM",
            position: "before"
        },
        NZD: {
            symbol: "NZ$",
            position: "before"
        },
        PHP: {
            symbol: "₱",
            position: "before"
        },
        SGD: {
            symbol: "S$",
            position: "before"
        },
        THB: {
            symbol: "฿",
            position: "before"
        },
        ZAR: {
            symbol: "R",
            position: "before"
        }
    };
    var _currency = options.currency, currency = _currency === void 0 ? "HUF" : _currency, _decimalPlaces = options.decimalPlaces, decimalPlaces = _decimalPlaces === void 0 ? 0 : _decimalPlaces, _thousandSeparator = options.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? " " : _thousandSeparator, _decimalSeparator = options.decimalSeparator, decimalSeparator = _decimalSeparator === void 0 ? "." : _decimalSeparator, symbolPosition // Valutajel pozíciója: 'before' vagy 'after' (opcionális, felülírja az alapértelmezettet)
     = options.symbolPosition;
    var currencyDetail = currencyDetails[currency] || {
        symbol: currency,
        position: "after"
    };
    var position = symbolPosition || currencyDetail.position;
    // Az ár tizedesjegyekre kerekítése
    var formattedPrice = Number(price).toFixed(decimalPlaces);
    // Tizedesjegyek és egész rész szétválasztása
    var parts = formattedPrice.split(".");
    var integerPart = parts[0];
    var decimalPart = parts[1] || "";
    // Ezerelválasztó hozzáadása
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    // Tizedes elválasztó hozzáadása
    formattedPrice = integerPart;
    if (decimalPlaces > 0) {
        formattedPrice += decimalSeparator + decimalPart;
    }
    // Valutajel hozzáadása a megfelelő pozícióba
    var currencySymbol = currencyDetail.symbol;
    if (position === "before") {
        formattedPrice = currencySymbol + " " + formattedPrice;
    } else {
        formattedPrice += " " + currencySymbol;
    }
    return formattedPrice;
};


/***/ }),

/***/ 2521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ getSzalagImageUrl; }
/* harmony export */ });
/* harmony import */ var _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84160);

var getSzalagImageUrl = function(variant) {
    switch(variant){
        case _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PFSzalagKiemelesVariant.AkciosAr */ .pxT.AkciosAr:
            return {
                badge: "/assets/badges/badge_akcios.png",
                ribbon: "/assets/ribbons/boxribbon_akcios.png"
            };
        case _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PFSzalagKiemelesVariant.Alkukepes */ .pxT.Alkukepes:
            return {
                badge: "/assets/badges/badge_alkukepes.png",
                ribbon: "/assets/ribbons/boxribbon_alkukepes.png"
            };
        case _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PFSzalagKiemelesVariant.IngyenesSzallitas */ .pxT.IngyenesSzallitas:
            return {
                badge: "/assets/badges/badge_ingyenszallitas.png",
                ribbon: "/assets/ribbons/boxribbon_ingyenszallitas.png"
            };
        case _client_swaggerClient__WEBPACK_IMPORTED_MODULE_0__/* .PFSzalagKiemelesVariant.UtolsoDarab */ .pxT.UtolsoDarab:
            return {
                badge: "/assets/badges/badge_utolsodarab.png",
                ribbon: "/assets/ribbons/boxribbon_utolsodarab.png"
            };
        default:
            return {
                badge: "",
                ribbon: ""
            };
    }
};


/***/ })

}]);